import { useState, useEffect, useMemo, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/lib/supabase";

export function Wordmark({ size = 16, pill = true }) {
  const texto = (
    <b style={{ fontWeight: 800, letterSpacing: "-.02em", fontSize: size, whiteSpace: "nowrap",
      background: "linear-gradient(180deg,var(--wm1,#16203A) 20%,var(--wm2,#41537A) 90%)", WebkitBackgroundClip: "text", backgroundClip: "text", color: "transparent" }}>
      Conta em Dia
    </b>
  );
  if (!pill) return texto;
  return (
    <span style={{ display: "inline-flex", alignItems: "center", padding: `${size * 0.38}px ${size * 0.85}px`, borderRadius: 99,
      background: "var(--glass2,rgba(255,255,255,.55))", border: "1px solid var(--stroke,rgba(255,255,255,.72))",
      backdropFilter: "blur(18px) saturate(180%)", WebkitBackdropFilter: "blur(18px) saturate(180%)",
      boxShadow: "0 6px 18px rgba(0,0,0,.14), inset 0 1.5px 0 rgba(255,255,255,.3)" }}>
      {texto}
    </span>
  );
}

// ============================================================
// CONTROLE — Finanças pessoais · Luís & Luiza
// Design: Apple Liquid Glass · Dados importados das planilhas em 27/08/2026
// ============================================================

const MESES = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"];
const MESES_FULL = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];

const IOS = {
  blue: "#007AFF", green: "#34C759", red: "#FF3B30", orange: "#FF9500",
  purple: "#AF52DE", teal: "#30B0C7", indigo: "#5856D6", pink: "#FF2D55",
  yellow: "#FFCC00", mint: "#00C7BE", brown: "#A2845E", gray: "#8E8E93",
};
const CORES_CAIXINHA = [IOS.red, IOS.orange, IOS.blue, IOS.purple, IOS.teal, IOS.indigo, IOS.green, IOS.pink, IOS.mint, IOS.brown];
// Fluxo de caixa importado da planilha (base 92.44 em 2025-08-01)
const FLUXO_BASE = { data: "2025-08-01", valor: 92.44 };
const FLUXO_LANC = [
  ["2025-08-02", 600.0, 686.03, 0],
  ["2025-08-03", 600.0, 395.4, 0],
  ["2025-08-04", 0.0, 200.0, 0],
  ["2025-08-05", 240.0, 142.4, 0],
  ["2025-08-07", 8816.0, 3660.83, 0],
  ["2025-08-08", 0.0, 4900.0, 0],
  ["2025-08-09", 0.0, 168.07, 0],
  ["2025-08-10", 500.0, 0.0, 0],
  ["2025-08-11", 1450.0, 1494.18, 0],
  ["2025-08-12", 0.0, 83.5, 0],
  ["2025-08-14", 0.0, 547.36, 0],
  ["2025-08-15", 150.0, 66.4, 0],
  ["2025-08-17", 400.0, 469.08, 0],
  ["2025-08-18", 200.0, 191.9, 0],
  ["2025-08-19", 100.0, 86.97, 0],
  ["2025-08-20", 0.0, 33.93, 0],
  ["2025-08-21", 260.0, 56.0, 0],
  ["2025-08-22", 0.0, 160.0, 0],
  ["2025-08-23", 250.0, 125.47, 0],
  ["2025-08-24", 150.0, 207.64, 0],
  ["2025-08-25", 200.0, 15.6, 0],
  ["2025-08-26", 150.0, 184.5, 0],
  ["2025-08-27", 0.0, 56.0, 0],
  ["2025-08-28", 300.0, 380.69, 0],
  ["2025-08-29", 250.0, 177.6, 0],
  ["2025-08-30", 220.0, 388.63, 0],
  ["2025-09-01", 230.0, 181.58, 0],
  ["2025-09-02", 300.0, 313.23, 0],
  ["2025-09-03", 600.0, 643.34, 0],
  ["2025-09-04", 2878.38, 2689.49, 0],
  ["2025-09-05", 8816.0, 8989.65, 0],
  ["2025-09-06", 658.44, 467.3, 0],
  ["2025-09-07", 0.0, 59.0, 0],
  ["2025-09-08", 5028.0, 8.29, 0],
  ["2025-09-09", 3000.0, 7812.76, 0],
  ["2025-09-10", 0.0, 30.69, 0],
  ["2025-09-11", 300.0, 70.0, 0],
  ["2025-09-12", 100.0, 572.66, 0],
  ["2025-09-13", 600.0, 623.09, 0],
  ["2025-09-14", 700.0, 554.0, 0],
  ["2025-09-15", 0.0, 155.5, 0],
  ["2025-09-18", 206.0, 56.66, 0],
  ["2025-09-19", 0.0, 153.89, 0],
  ["2025-09-20", 313.23, 210.46, 0],
  ["2025-09-21", 0.0, 11.4, 0],
  ["2025-09-22", 100.0, 142.76, 0],
  ["2025-09-23", 0.0, 52.57, 0],
  ["2025-09-24", 100.0, 76.31, 0],
  ["2025-09-25", 160.0, 0.0, 0],
  ["2025-09-26", 0.0, 160.0, 0],
  ["2025-09-27", 0.0, 63.24, 0],
  ["2025-09-28", 180.0, 190.8, 0],
  ["2025-09-29", 100.0, 95.4, 0],
  ["2025-09-30", 500.0, 48.0, 0],
  ["2025-10-01", 0.0, 142.76, 0],
  ["2025-10-02", 0.0, 21.98, 0],
  ["2025-10-03", 50.0, 220.0, 0],
  ["2025-10-04", 0.0, 25.0, 0],
  ["2025-10-05", 234.0, 257.07, 0],
  ["2025-10-07", 9676.0, 5432.45, 0],
  ["2025-10-08", 0.0, 4125.69, 0],
  ["2025-10-09", 170.0, 284.8, 0],
  ["2025-10-11", 280.0, 304.51, 0],
  ["2025-10-12", 580.0, 28.87, 0],
  ["2025-10-13", 224.7, 100.0, 0],
  ["2025-10-14", 0.0, 579.36, 0],
  ["2025-10-15", 0.0, 15.28, 0],
  ["2025-10-16", 616.1, 690.4, 0],
  ["2025-10-17", 443.0, 448.97, 0],
  ["2025-10-18", 100.0, 122.0, 0],
  ["2025-10-19", 100.0, 30.0, 0],
  ["2025-10-20", 160.0, 160.0, 0],
  ["2025-10-21", 0.0, 57.0, 0],
  ["2025-10-22", 180.0, 96.49, 0],
  ["2025-10-24", 42.85, 107.0, 0],
  ["2025-10-25", 300.0, 231.34, 0],
  ["2025-10-26", 0.0, 79.24, 0],
  ["2025-10-27", 230.0, 224.9, 0],
  ["2025-10-28", 55.55, 11.98, 0],
  ["2025-10-29", 143.0, 190.63, 0],
  ["2025-10-30", 0.0, 5.3, 0],
  ["2025-11-01", 150.0, 72.0, 0],
  ["2025-11-02", 7.41, 36.62, 0],
  ["2025-11-03", 1100.0, 1051.22, 0],
  ["2025-11-04", 0.0, 47.98, 0],
  ["2025-11-05", 318.88, 76.36, 0],
  ["2025-11-06", 0.0, 29.19, 0],
  ["2025-11-07", 300.0, 236.0, 0],
  ["2025-11-08", 0.0, 325.69, 0],
  ["2025-11-09", 0.0, 5.09, 0],
  ["2025-11-10", 0.0, 28.75, 0],
  ["2025-11-11", 471.74, 0.0, 0],
  ["2025-11-12", 50.0, 0.0, 0],
  ["2025-11-13", 8674.0, 8763.64, 0],
  ["2025-11-14", 0.0, 123.38, 0],
  ["2025-11-15", 0.0, 129.29, 0],
  ["2025-11-16", 745.86, 778.99, 0],
  ["2025-11-17", 0.0, 142.76, 0],
  ["2025-11-18", 380.0, 229.19, 0],
  ["2025-11-19", 250.0, 380.14, 0],
  ["2025-11-20", 500.0, 500.0, 0],
  ["2025-11-21", 2460.0, 2400.0, 0],
  ["2025-11-22", 134.43, 105.2, 0],
  ["2025-11-23", 280.0, 280.0, 0],
  ["2025-11-24", 2070.0, 2055.0, 0],
  ["2025-11-25", 2793.0, 2893.69, 0],
  ["2025-11-26", 0.0, 6.07, 0],
  ["2025-11-27", 100.0, 50.0, 0],
  ["2025-11-28", 1.03, 25.17, 0],
  ["2025-11-29", 150.0, 120.0, 0],
  ["2025-11-30", 0.0, 83.0, 0],
  ["2025-12-01", 1.05, 0.0, 0],
  ["2025-12-02", 0.0, 48.91, 0],
  ["2025-12-03", 0.0, 32.5, 0],
  ["2025-12-04", 0.0, 22.0, 0],
  ["2025-12-05", 100.0, 0.0, 0],
  ["2025-12-06", 11678.81, 8094.75, 0],
  ["2025-12-08", 0.0, 502.3, 0],
  ["2025-12-09", 0.0, 34.28, 0],
  ["2025-12-10", 351.9, 0.0, 0],
  ["2025-12-11", 0.0, 167.73, 0],
  ["2025-12-12", 2.97, 622.46, 0],
  ["2025-12-13", 1796.44, 461.0, 0],
  ["2025-12-15", 0.0, 30.0, 0],
  ["2025-12-16", 2.14, 0.0, 0],
  ["2025-12-17", 4.22, 88.04, 0],
  ["2025-12-18", 0.86, 687.93, 0],
  ["2025-12-19", 1.08, 318.01, 0],
  ["2025-12-20", 178.15, 438.0, 0],
  ["2025-12-21", 0.0, 90.0, 0],
  ["2025-12-22", 0.13, 271.0, 0],
  ["2025-12-23", 0.0, 137.19, 0],
  ["2025-12-24", 2.28, 0.0, 0],
  ["2025-12-25", 1.21, 0.0, 0],
  ["2025-12-26", 1000.0, 906.46, 0],
  ["2025-12-27", 1.76, 185.0, 0],
  ["2025-12-28", 0.0, 100.14, 0],
  ["2025-12-29", 1.83, 81.23, 0],
  ["2025-12-30", 0.96, 0.0, 0],
  ["2025-12-31", 0.96, 51.59, 0],
  ["2026-01-03", 0.73, 356.0, 0],
  ["2026-01-04", 2.35, 249.0, 0],
  ["2026-01-05", 50.0, 0.0, 0],
  ["2026-01-06", 0.63, 0.0, 0],
  ["2026-01-07", 2711.0, 2740.92, 0],
  ["2026-01-08", 9230.69, 6238.79, 0],
  ["2026-01-09", 199.74, 0.0, 0],
  ["2026-01-10", 0.0, 843.0, 0],
  ["2026-01-11", 3.34, 240.0, 0],
  ["2026-01-13", 0.0, 25.99, 0],
  ["2026-01-14", 2.28, 199.43, 0],
  ["2026-01-15", 1.4, 482.5, 0],
  ["2026-01-17", 0.0, 90.0, 0],
  ["2026-01-18", 8.3, 630.91, 0],
  ["2026-01-19", 0.0, 80.9, 0],
  ["2026-01-20", 0.96, 0.0, 0],
  ["2026-01-21", 2.48, 0.0, 0],
  ["2026-01-22", 0.97, 179.82, 0],
  ["2026-01-23", 0.36, 12.99, 0],
  ["2026-01-25", 3.5, 403.06, 0],
  ["2026-01-26", 0.0, 160.0, 0],
  ["2026-01-27", 0.57, 20.0, 0],
  ["2026-01-28", 0.57, 6.07, 0],
  ["2026-01-29", 1.58, 200.0, 0],
  ["2026-01-30", 0.46, 0.0, 0],
  ["2026-01-31", 2.47, 492.4, 0],
  ["2026-02-04", 1.67, 0.0, 0],
  ["2026-02-05", 62.54, 30.0, 0],
  ["2026-02-06", 11675.2, 7209.54, 0],
  ["2026-02-07", 1.71, 116.0, 0],
  ["2026-02-08", 33.3, 679.69, 0],
  ["2026-02-09", 0.0, 988.62, 0],
  ["2026-02-11", 20.65, 22.9, 0],
  ["2026-02-12", 1.38, 1095.58, 0],
  ["2026-02-13", 0.0, 337.73, 0],
  ["2026-02-14", 0.0, 168.15, 0],
  ["2026-02-17", 0.0, 161.14, 0],
  ["2026-02-19", 0.0, 86.05, 0],
  ["2026-02-20", 50.0, 463.03, 0],
  ["2026-02-22", 0.0, 300.42, 0],
  ["2026-02-25", 0.17, 200.5, 0],
  ["2026-02-26", 0.16, 0.0, 0],
  ["2026-02-27", 0.0, 18.21, 0],
  ["2026-02-28", 0.0, 67.99, 0],
  ["2026-03-01", 50.0, 0.93, 0],
  ["2026-03-03", 0.12, 0.0, 0],
  ["2026-03-04", 0.26, 24.0, 0],
  ["2026-03-06", 11956.0, 5884.0, 0],
  ["2026-03-07", 0.0, 1280.56, 0],
  ["2026-03-08", 0.0, 401.59, 0],
  ["2026-03-09", 0.0, 96.93, 0],
  ["2026-03-10", 8.54, 389.09, 0],
  ["2026-03-11", 245.41, 260.0, 0],
  ["2026-03-13", 0.27, 753.43, 0],
  ["2026-03-14", 0.0, 725.8, 0],
  ["2026-03-15", 7.24, 274.86, 0],
  ["2026-03-16", 0.0, 21.54, 0],
  ["2026-03-17", 0.41, 0.0, 0],
  ["2026-03-18", 1.06, 0.0, 0],
  ["2026-03-19", 0.0, 186.05, 0],
  ["2026-03-20", 0.0, 158.21, 0],
  ["2026-03-21", 0.0, 364.07, 0],
  ["2026-03-24", 0.62, 0.0, 0],
  ["2026-03-25", 0.92, 35.0, 0],
  ["2026-03-26", 4.87, 768.21, 0],
  ["2026-03-28", 17.72, 0.0, 0],
  ["2026-03-29", 0.0, 20.0, 0],
  ["2026-03-30", 50.0, 0.0, 0],
  ["2026-03-31", 0.48, 200.0, 0],
  ["2026-04-01", 1.53, 0.0, 0],
  ["2026-04-02", 0.36, 0.0, 0],
  ["2026-04-03", 0.0, 166.38, 0],
  ["2026-04-04", 0.0, 10.12, 0],
  ["2026-04-05", 0.0, 15.0, 0],
  ["2026-04-06", 2.8, 400.95, 0],
  ["2026-04-07", 2.16, 0.0, 0],
  ["2026-04-08", 11581.0, 9025.42, 0],
  ["2026-04-09", 0.0, 118.0, 0],
  ["2026-04-10", 2.7, 42.28, 0],
  ["2026-04-12", 3.88, 610.18, 0],
  ["2026-04-14", 1.69, 302.59, 0],
  ["2026-04-15", 0.0, 474.03, 0],
  ["2026-04-16", 0.0, 5.0, 0],
  ["2026-04-17", 1.45, 145.16, 0],
  ["2026-04-18", 80.0, 45.0, 0],
  ["2026-04-19", 0.0, 480.0, 0],
  ["2026-04-20", 2.06, 86.05, 0],
  ["2026-04-21", 0.0, 24.87, 0],
  ["2026-04-22", 1.67, 193.69, 0],
  ["2026-04-23", 0.0, 90.0, 0],
  ["2026-04-24", 54.0, 0.0, 0],
  ["2026-04-30", 1.9, 0.0, 0],
  ["2026-05-04", 3.53, 30.0, 0],
  ["2026-05-06", 0.0, 20.16, 0],
  ["2026-05-08", 15781.0, 726.64, 0],
  ["2026-05-09", 0.0, 10035.25, 0],
  ["2026-05-10", 0.0, 200.0, 0],
  ["2026-05-12", 4.75, 403.53, 0],
  ["2026-05-13", 2.45, 26.4, 0],
  ["2026-05-14", 1.54, 628.55, 0],
  ["2026-05-15", 3.6, 284.36, 0],
  ["2026-05-16", 0.0, 75.5, 0],
  ["2026-05-18", 1.68, 0.0, 0],
  ["2026-05-19", 1.81, 300.05, 0],
  ["2026-05-20", 0.0, 194.3, 0],
  ["2026-05-21", 2.67, 0.0, 0],
  ["2026-05-22", 1.36, 0.0, 0],
  ["2026-05-25", 87.84, 655.14, 0],
  ["2026-05-27", 3.97, 0.0, 0],
  ["2026-05-28", 318.37, 90.0, 0],
  ["2026-06-09", 0.0, 400.94, 0],
  ["2026-06-10", 0.0, 1975.37, 0],
  ["2026-06-11", 11106.0, 5374.77, 0],
  ["2026-06-12", 0.0, 753.85, 0],
  ["2026-06-14", 5.51, 575.0, 0],
  ["2026-06-15", 0.0, 20.0, 0],
  ["2026-06-16", 2.53, 10.0, 0],
  ["2026-06-17", 2.56, 0.0, 0],
  ["2026-06-18", 68.54, 0.0, 0],
  ["2026-06-19", 2.33, 150.05, 0],
  ["2026-06-22", 0.0, 450.2, 0],
  ["2026-06-23", 0.0, 149.37, 0],
  ["2026-06-24", 3.24, 263.0, 0],
  ["2026-06-25", 5.21, 40.06, 0],
  ["2026-06-26", 0.0, 50.0, 0],
  ["2026-06-27", 0.0, 503.84, 0],
  ["2026-06-28", 0.0, 425.0, 0],
  ["2026-06-29", 0.0, 276.8, 0],
  ["2026-06-30", 2.98, 0.0, 0],
  ["2026-07-02", 2.16, 105.0, 0],
  ["2026-07-03", 0.29, 137.8, 0],
  ["2026-07-05", 0.0, 290.17, 0],
  ["2026-07-06", 2.52, 198.0, 0],
  ["2026-07-07", 8354.1, 4077.15, 0],
  ["2026-07-08", 3.15, 55.0, 0],
  ["2026-07-09", 3.16, 64.0, 0],
  ["2026-07-10", 3.17, 0.0, 0],
  ["2026-07-11", 0.0, 269.23, 0],
  ["2026-07-12", 2.67, 19.5, 0],
  ["2026-07-13", 2975.0, 2975.0, 0],
  ["2026-07-14", 0.0, 592.59, 0],
  ["2026-07-15", 5.27, 0.0, 0],
  ["2026-07-16", 0.38, 85.0, 0],
  ["2026-07-17", 2.4, 147.54, 0],
  ["2026-07-19", 0.0, 375.3, 0],
  ["2026-07-20", 6.71, 0.0, 0],
  ["2026-07-21", 3.28, 428.0, 0],
  ["2026-07-22", 1.58, 159.55, 0],
  ["2026-07-23", 4.61, 0.0, 0],
  ["2026-07-24", 11.0, 0.0, 0],
  ["2026-07-25", 0.0, 25.0, 0],
  ["2026-07-26", 0.0, 190.0, 0],
  ["2026-07-27", 1.3, 0.0, 0],
  ["2026-07-28", 0.0, 8.03, 0],
  ["2026-07-29", 1.95, 0.0, 0],
  ["2026-07-30", 1.98, 429.9, 0],
  ["2026-08-01", 0.0, 27.4, 0],
  ["2026-08-02", 4.88, 273.4, 0],
  ["2026-08-03", 0.0, 342.63, 0],
  ["2026-08-04", 0.0, 190.0, 0],
  ["2026-08-05", 1.04, 120.0, 0],
  ["2026-08-06", 4.51, 0.0, 0],
  ["2026-08-07", 0.0, 70.0, 0],
  ["2026-08-08", 0.0, 355.23, 0],
  ["2026-08-09", 3.85, 0.0, 0],
  ["2026-08-10", 6330.25, 1229.08, 0],
  ["2026-08-11", 0.0, 1.77, 0],
  ["2026-08-12", 0.0, 55.0, 0],
  ["2026-08-13", 6.26, 0.0, 0],
  ["2026-08-14", 5.25, 995.91, 0],
  ["2026-08-16", 0.0, 466.47, 0],
  ["2026-08-17", 0.0, 45.54, 0],
  ["2026-08-18", 2.85, 0.0, 0],
  ["2026-08-19", 2.85, 0.0, 0],
  ["2026-08-20", 1.83, 296.49, 0],
  ["2026-08-21", 2.68, 0.0, 0],
  ["2026-08-24", 4.0, 210.0, 0],
  ["2026-08-25", 3.76, 327.0, 0],
  ["2026-08-26", 1.82, 36.23, 0],
  ["2026-08-27", 2.4, 0.0, 0],
  ["2026-09-05", 7145.0, 1100.0, 1],
  ["2026-09-08", 0.0, 355.23, 1],
  ["2026-09-15", 0.0, 154.05, 1],
  ["2026-10-05", 7145.0, 1100.0, 1],
  ["2026-10-08", 0.0, 355.23, 1],
  ["2026-11-05", 7145.0, 1100.0, 1],
  ["2026-11-08", 0.0, 355.23, 1],
  ["2026-12-05", 7145.0, 1100.0, 1],
  ["2026-12-08", 0.0, 355.23, 1]
];

const SEED = {
  seedVersion: 2,
  caixinhas: [
    { id: "emergencia", nome: "Emergência", icone: "shield", cor: IOS.red, valor: 18893, metas: { 2026: 28000, 2027: 40000 } },
    { id: "reforma", nome: "Reforma", icone: "hammer", cor: IOS.orange, valor: 11374, metas: {} },
    { id: "investimento", nome: "Investimento", icone: "chart", cor: IOS.blue, valor: 34251, metas: { 2026: 38000, 2027: 85000 } },
    { id: "lazer", nome: "Lazer", icone: "beach", cor: IOS.teal, valor: 2294, metas: { 2027: 2000 } },
    { id: "diaadia", nome: "Dia a dia", icone: "coffee", cor: IOS.purple, valor: 4649.26, metas: {}, noFluxo: true },
    { id: "conta", nome: "Conta", icone: "bank", cor: IOS.indigo, valor: 41.62, metas: {}, noFluxo: true },
    { id: "especie", nome: "Espécie", icone: "cash", cor: IOS.green, valor: 3650, metas: {} },
  ],
  historico: [
    { data: "2026-08-27", caixinha: "Emergência", anterior: 18884, novo: 18893 },
    { data: "2026-08-27", caixinha: "Reforma", anterior: 11368, novo: 11374 },
    { data: "2026-08-27", caixinha: "Investimento", anterior: 34234, novo: 34251 },
    { data: "2026-08-27", caixinha: "Lazer", anterior: 2293, novo: 2294 },
    { data: "2026-08-27", caixinha: "Dia a dia", anterior: 4646.86, novo: 4649.26 },
  ],
  snapshots: [
    { data: "2026-08-26", total: 75117.48 },
    { data: "2026-08-27", total: 75152.88 },
  ],
  fluxo: {
    base: FLUXO_BASE,
    lanc: FLUXO_LANC.map(([data, e, s, plan]) => ({ data, e, s, plan: !!plan })),
    gastoDiario: 193,
  },
  economia: {
    2025: [[4562,0],[13933,3738],[8264,3738],[8456,3738],[9306,3738],[13235,3738],[14712.81,3738],[9566,2245],[14344,2245],[13585.2,2245],[20936.35,2000],[15126.75,3800]],
    2026: [[12224.38,1675],[11846.78,1675],[12343.92,200],[21737.2,10000],[25674.57,9460],[11198.9,4400],[11386.68,6175],[6378.23,0],[7145,0],[7145,0],[7145,0],[7145,0]],
  },
  custos: {
    2026: [
      { nome: "Condomínio", orcado: 600, meses: [483, 493.21, 512.24, 474.03, 470.29, 469.39, 467.55, 491.79, 0, 0, 0, 0] },
      { nome: "Celesc", orcado: 180, meses: [183, 161.14, 171.81, 157.59, 158.26, 142.34, 125.04, 170.12, 154.05, 0, 0, 0] },
      { nome: "Mercado", orcado: 1400, meses: [1466.44, 1161.96, 1063.43, 1138.31, 570.65, 1407.7, 825.73, 1197.82, 0, 0, 0, 0] },
      { nome: "Marmita", orcado: 0, meses: [258, 256, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0] },
      { nome: "Plano de saúde", orcado: 325, meses: [325.69, 325.69, 325.69, 325.69, 325.69, 325.69, 325.69, 325.69, 325.69, 325.69, 325.69, 325.69] },
      { nome: "Carro", orcado: 900, meses: [1180, 400, 1115.07, 805.8, 925.38, 485.8, 627.63, 807.6, 0, 0, 0, 0] },
      { nome: "Celular / Internet", orcado: 180, meses: [160, 160, 160, 160, 160, 170, 170, 170, 170, 170, 170, 170] },
      { nome: "Dia a dia", orcado: 917, meses: [628.13, 904.4, 658.29, 892.67, 864.89, 925.02, 842.38, 1025.33, 0, 0, 0, 0] },
      { nome: "Fatura", orcado: 1000, meses: [979.57, 561.38, 1895.55, 2279.54, 1984.16, 366.85, 450.27, 157.45, 69.33, 69.33, 0, 0] },
      { nome: "MEI", orcado: 0, meses: [80.9, 86.05, 86.05, 86.05, 86.05, 86.05, 86.05, 0, 0, 0, 0, 0] },
      { nome: "IPTU", orcado: 0, meses: [0, 732.49, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0] },
      { nome: "IPVA / Lic / Seguro", orcado: 0, meses: [0, 0, 0, 1562.13, 1562.13, 1711.5, 0, 0, 0, 0, 0, 0] },
      { nome: "IR", orcado: 0, meses: [2110.75, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0] },
      { nome: "Ambiental", orcado: 0, meses: [0, 402.37, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0] },
      { nome: "Contador", orcado: 300, meses: [600, 0, 0, 250, 0, 0, 0, 0, 0, 0, 0, 0] },
      { nome: "Viagem", orcado: 0, meses: [490.22, 490.22, 100, 0, 10480.11, 0, 0, 0, 0, 0, 0, 0] },
      { nome: "Academia", orcado: 198, meses: [0, 0, 0, 0, 0, 0, 198, 198, 198, 198, 198, 198] },
      { nome: "Casa", orcado: 0, meses: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0] },
    ],
  },
};

// ---------- Utilitários ----------
const fmt = (v) => (v ?? 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL", maximumFractionDigits: 2 });
const fmt0 = (v) => (v ?? 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL", maximumFractionDigits: 0 });
const fmtShort = (v) => {
  const n = v ?? 0;
  if (Math.abs(n) >= 1000) return "R$ " + (n / 1000).toLocaleString("pt-BR", { maximumFractionDigits: 1 }) + " mil";
  return fmt(n);
};
const parseBR = (s) => {
  if (typeof s === "number") return s;
  if (!s) return NaN;
  const alt = String(s).trim().replace(/R\$\s?/g, "");
  if (/^-?\d+(\.\d{1,2})?$/.test(alt)) return parseFloat(alt);
  return parseFloat(alt.replace(/\./g, "").replace(",", "."));
};
const hoje = () => new Date().toISOString().slice(0, 10);
const fmtData = (iso) => { const [y, m, d] = iso.split("-"); return `${d}/${m}/${y.slice(2)}`; };
const fmtDataLonga = (iso) => { const [y, m, d] = iso.split("-"); return `${parseInt(d)} de ${MESES_FULL[parseInt(m) - 1].toLowerCase()} de ${y}`; };
const diaSemana = (iso) => ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"][new Date(iso + "T12:00:00").getDay()];
const diasEntre = (a, b) => Math.round((new Date(b) - new Date(a)) / 86400000);
const addDias = (iso, n) => { const d = new Date(iso + "T12:00:00"); d.setDate(d.getDate() + n); return d.toISOString().slice(0, 10); };

// Detecta se o texto digitado contém uma conta (para exibir o resultado)
const temOperacao = (v) => /[+\-*/]/.test(String(v || "").slice(1));

// ---------- Dados no Supabase ----------
async function loadData() {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session) return null;
    const { data, error } = await supabase.from("controle_app").select("data").eq("user_id", session.user.id).maybeSingle();
    if (error) { console.error("loadData:", error); return null; }
    return data ? data.data : undefined;
  } catch (e) { console.error(e); return null; }
}
async function saveData(d) {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session) return;
    const { error } = await supabase.from("controle_app").upsert(
      { user_id: session.user.id, data: d, updated_at: new Date().toISOString() }, { onConflict: "user_id" });
    if (error) console.error("saveData:", error);
  } catch (e) { console.error(e); }
}

function seedNovo() {
  const ano = new Date().getFullYear();
  return {
    seedVersion: 2,
    tema: "auto",
    caixinhas: [
      { id: "emergencia", nome: "Emergência", icone: "shield", cor: IOS.red, valor: 0, metas: {} },
      { id: "investimento", nome: "Investimento", icone: "chart", cor: IOS.blue, valor: 0, metas: {} },
      { id: "diaadia", nome: "Dia a dia", icone: "coffee", cor: IOS.purple, valor: 0, metas: {}, noFluxo: true },
      { id: "conta", nome: "Conta", icone: "bank", cor: IOS.indigo, valor: 0, metas: {}, noFluxo: true },
    ],
    historico: [],
    snapshots: [{ data: hoje(), total: 0 }],
    fluxo: { base: { data: hoje(), valor: 0 }, lanc: [], gastoDiario: 150 },
    economia: { [ano]: Array.from({ length: 12 }, () => [0, 0]) },
    custos: { [ano]: ["Moradia", "Mercado", "Transporte", "Saúde", "Contas fixas", "Lazer"].map((nome) => ({ nome, orcado: 0, meses: Array(12).fill(0) })) },
  };
}

function migrar(d) {
  d.caixinhas.forEach((c, i) => {
    if (!c.icone) c.icone = "💰";
    if (!c.cor) c.cor = CORES_CAIXINHA[i % CORES_CAIXINHA.length];
  });
  if (!d.snapshots) d.snapshots = [];
  if (!d.historico) d.historico = [];
  if (!d.custos) d.custos = {};
  if (!d.fluxo) d.fluxo = JSON.parse(JSON.stringify(SEED.fluxo));
  if (!d.economia) d.economia = JSON.parse(JSON.stringify(SEED.economia));
  if (d.fluxo.gastoDiario == null) d.fluxo.gastoDiario = 193;
  if (!d.tema) d.tema = "auto";
  // lançamentos antigos: sem tipo definido, entram como movimento comum da conta
  d.fluxo.lanc.forEach((l) => {
    if (!l.tipo) l.tipo = l.auto ? "auto" : "comum";
    if (l.valor == null) l.valor = l.e || l.s || 0;
    // "aplicado" marca se o efeito na caixinha já foi de fato realizado.
    // Lançamentos antigos (sem esse campo) nunca foram "agendados" no sentido novo,
    // então assumimos que já foram aplicados quando criados — exceto os que ainda
    // estão marcados como planejados (plan: true), esses ainda não.
    if (l.aplicado === undefined) l.aplicado = !l.plan;
  });
  // Promove agendamentos cuja data já chegou: aplica o efeito na caixinha agora,
  // automaticamente, sem exigir que o usuário reabra e salve o lançamento.
  d.fluxo.lanc.forEach((l) => {
    if (l.plan && !l.aplicado && l.data <= hoje()) {
      moverSaldoCaixinhas(d, l, 1);
      l.aplicado = true;
      l.plan = false;
    }
  });
  return d;
}

// ---------- Motor do fluxo de caixa ----------
// Cada lançamento tem origem e destino. O "saldo disponível" é a soma das
// caixinhas marcadas com noFluxo (por padrão Conta e Dia a dia).
// Um lançamento só mexe no fluxo quando cruza a fronteira do disponível.
const ehDisponivel = (caixinhas, id) => !!caixinhas.find((c) => c.id === id && c.noFluxo);

// Move o saldo de verdade entre caixinhas (sinal +1 aplica, -1 desfaz).
// Função pura e única fonte da verdade: usada tanto na migração (promover
// agendamentos vencidos) quanto nas ações do app (salvar/excluir lançamento),
// para que "aplicar" e "desfazer" nunca mais se baseiem em comparar datas de novo.
function moverSaldoCaixinhas(d, l, sinal) {
  const v = (l.valor != null ? l.valor : (l.e || l.s || 0)) * sinal;
  if (!v) return;
  const mexer = (id, delta) => {
    const c = d.caixinhas.find((x) => x.id === id);
    if (!c) return;
    const antes = c.valor;
    c.valor = Math.round((c.valor + delta) * 100) / 100;
    d.historico.push({ data: l.data, caixinha: c.nome, anterior: antes, novo: c.valor, transf: true });
  };
  if (l.tipo === "entrada" && l.destino) mexer(l.destino, v);
  else if (l.tipo === "gasto" && l.origem) mexer(l.origem, -v);
  else if (l.tipo === "transf") { if (l.origem) mexer(l.origem, -v); if (l.destino) mexer(l.destino, v); }
}

function efeitoNoFluxo(l, caixinhas) {
  // formato antigo (sem origem/destino): mantém o comportamento original
  if (!l.tipo || l.tipo === "auto" || (!l.origem && !l.destino)) return { e: l.e || 0, s: l.s || 0 };
  const v = l.valor != null ? l.valor : (l.e || l.s || 0);
  const entrouNoPool = l.destino && ehDisponivel(caixinhas, l.destino);
  const saiuDoPool = l.origem && ehDisponivel(caixinhas, l.origem);
  if (l.tipo === "entrada") return { e: entrouNoPool ? v : 0, s: 0 };
  if (l.tipo === "gasto") return { e: 0, s: saiuDoPool ? v : 0 };
  if (l.tipo === "transf") {
    if (saiuDoPool && !entrouNoPool) return { e: 0, s: v };   // ex.: Conta → Investimento
    if (!saiuDoPool && entrouNoPool) return { e: v, s: 0 };   // ex.: Emergência → Conta
    return { e: 0, s: 0 };                                    // ex.: Conta → Dia a dia (interno)
  }
  return { e: l.e || 0, s: l.s || 0 };
}

// Descreve o lançamento em uma linha ("Conta → Investimento")
function descreverLanc(l, caixinhas) {
  const nome = (id) => caixinhas.find((c) => c.id === id)?.nome;
  if (l.tipo === "entrada") return "entrou em " + (nome(l.destino) || "Conta");
  if (l.tipo === "gasto") return (l.categoria || "gasto") + " · " + (nome(l.origem) || "Conta");
  if (l.tipo === "transf") return (nome(l.origem) || "?") + " → " + (nome(l.destino) || "?");
  return l.desc || "";
}

function calcularFluxo(fluxo, caixinhas, ateData) {
  const mapa = {};
  fluxo.lanc.forEach((l) => {
    if (!mapa[l.data]) mapa[l.data] = { e: 0, s: 0, itens: [] };
    const ef = efeitoNoFluxo(l, caixinhas);
    mapa[l.data].e += ef.e;
    mapa[l.data].s += ef.s;
    mapa[l.data].itens.push(l);
  });
  // O saldo de hoje é sempre a soma real das caixinhas disponíveis
  const saldoHoje = caixinhas.filter((c) => c.noFluxo).reduce((s, c) => s + c.valor, 0);
  const H = hoje();
  const dias = [];
  let d = fluxo.base.data;
  let saldo = fluxo.base.valor;
  while (d <= ateData) {
    const mv = mapa[d];
    const futuro = d > H;
    let e = mv ? mv.e : 0, s = mv ? mv.s : 0, estimado = false;
    if (futuro && !mv) { s = fluxo.gastoDiario; estimado = true; }
    if (d === H) saldo = saldoHoje;            // reancora no valor real
    else saldo = saldo + e - s;
    dias.push({ data: d, e, s, saldo: Math.round(saldo * 100) / 100, futuro, estimado, itens: mv ? mv.itens : [] });
    d = addDias(d, 1);
  }
  return dias;
}


// ---------- Estilos (Liquid Glass) ----------
const CSS = `
:root,.app{
  --label:#0B1220; --sec:#3C3C43; --sec60:rgba(42,48,64,.74); --sec30:rgba(42,48,64,.38);
  --blue:#007AFF; --green:#248A3D; --greenB:#34C759; --red:#D70015; --redB:#FF3B30; --orange:#FF9500;
  --glass:rgba(255,255,255,.62); --glass2:rgba(255,255,255,.46); --stroke:rgba(255,255,255,.72);
  --sep:rgba(60,60,67,.17);
  --bgGrad:linear-gradient(180deg,#EAF1FB 0%,#F0EEF9 45%,#EBF3F1 100%);
  --segOn:rgba(255,255,255,.92); --inpBg:rgba(255,255,255,.55); --updBg:rgba(255,255,255,.55);
  --tabbarBg:rgba(255,255,255,.55); --sheetBg:linear-gradient(180deg,rgba(255,255,255,.82),rgba(244,247,252,.76));
  --toastBg:rgba(255,255,255,.72); --rowActive:rgba(255,255,255,.4);
  --cardShadow:0 12px 36px rgba(40,60,110,.13), inset 0 1px 0 rgba(255,255,255,.9), inset 0 -1px 0 rgba(255,255,255,.25);
  --wm1:#16203A; --wm2:#41537A;
  --b1c:#AFCBFF; --b2c:#D9C7FF; --b3c:#B6F0DC; --b4c:#FFE1BD; --blobOp:.55;
  --amber:#8a5200; --amberBg:rgba(255,149,0,.14); --amberLn:rgba(255,149,0,.3);
}
.app[data-theme="dark"]{
  --label:#F2F4F8; --sec:#C9CDD6; --sec60:rgba(220,226,238,.66); --sec30:rgba(220,226,238,.32);
  --blue:#0A84FF; --green:#34D065; --greenB:#30D158; --red:#FF6961; --redB:#FF453A; --orange:#FF9F0A;
  --glass:rgba(38,44,58,.55); --glass2:rgba(46,53,70,.45); --stroke:rgba(255,255,255,.14);
  --sep:rgba(255,255,255,.12);
  --bgGrad:linear-gradient(180deg,#0B0F16 0%,#0E1220 45%,#0B1412 100%);
  --segOn:rgba(255,255,255,.16); --inpBg:rgba(255,255,255,.09); --updBg:rgba(255,255,255,.07);
  --tabbarBg:rgba(24,28,38,.62); --sheetBg:linear-gradient(180deg,rgba(34,39,52,.94),rgba(24,28,40,.92));
  --toastBg:rgba(44,50,66,.85); --rowActive:rgba(255,255,255,.08);
  --cardShadow:0 14px 40px rgba(0,0,0,.5), inset 0 1px 0 rgba(255,255,255,.1);
  --wm1:#E8ECF6; --wm2:#9AA8C8;
  --b1c:#1B3A6B; --b2c:#3A2B6B; --b3c:#134B3A; --b4c:#5B3A12; --blobOp:.5;
  --amber:#FFB84D; --amberBg:rgba(255,159,10,.15); --amberLn:rgba(255,159,10,.32);
}
*{box-sizing:border-box;margin:0;padding:0;-webkit-tap-highlight-color:transparent}
.app{min-height:100vh;color:var(--label);position:relative;
  font-family:-apple-system,BlinkMacSystemFont,"SF Pro Text","SF Pro Display","Helvetica Neue",Inter,sans-serif;
  padding-top:env(safe-area-inset-top);padding-bottom:calc(122px + env(safe-area-inset-bottom));font-size:17px;-webkit-text-size-adjust:100%;overscroll-behavior-y:none;-webkit-font-smoothing:antialiased;
  background:var(--bgGrad)}
.blobs{position:fixed;inset:0;z-index:0;pointer-events:none;overflow:hidden}
.blob{position:absolute;border-radius:50%;filter:blur(70px);opacity:var(--blobOp);transition:background .5s}
.b1{width:420px;height:420px;background:var(--b1c);top:-120px;left:-90px}
.b2{width:380px;height:380px;background:var(--b2c);top:22%;right:-140px}
.b3{width:460px;height:460px;background:var(--b3c);bottom:-140px;left:-60px}
.b4{width:300px;height:300px;background:var(--b4c);bottom:28%;right:-60px;opacity:.4}
.wrap{max-width:680px;margin:0 auto;padding:0 16px;position:relative;z-index:1}
@media(min-width:1024px){.wrap{max-width:1180px;padding:0 28px}}
.cols{display:grid;grid-template-columns:1fr;gap:0;align-items:start}
@media(min-width:1024px){.cols{grid-template-columns:minmax(0,7fr) minmax(0,5fr);gap:20px}}
.stack{min-width:0}
.two-col-cards{display:grid;grid-template-columns:1fr;gap:12px;align-items:stretch}
.two-col-cards>.card{display:flex;min-height:86px}
.two-col-cards>.card>.row{flex:1;width:100%}
@media(min-width:640px){.two-col-cards{grid-template-columns:1fr 1fr}}
@media(min-width:1024px){.two-col-cards{grid-template-columns:1fr 1fr 1fr}}
.full{grid-column:1/-1}
.num{font-variant-numeric:tabular-nums}
.lt{font-size:clamp(28px,7.5vw,34px);font-weight:800;letter-spacing:.01em;padding:22px 0 2px}
@media(min-width:1024px){.lt{font-size:40px;padding-top:30px}}
.lt-sub{font-size:15px;color:var(--sec60);padding-bottom:12px}
.section-h{font-size:13px;font-weight:700;color:var(--sec60);text-transform:uppercase;letter-spacing:.06em;margin:24px 6px 8px}
.card{background:var(--glass);border-radius:24px;overflow:hidden;position:relative;
  backdrop-filter:blur(26px) saturate(180%);-webkit-backdrop-filter:blur(26px) saturate(180%);
  border:1px solid var(--stroke);
  box-shadow:var(--cardShadow)}
.card+.card{margin-top:12px}
.pad{padding:18px}
.row{display:flex;align-items:center;gap:12px;padding:14px 18px;min-height:56px;position:relative}
.row:active{background:var(--rowActive)}
.row+.row::before{content:"";position:absolute;top:0;left:62px;right:0;height:1px;background:var(--sep)}
.row.noicon+.row.noicon::before{left:18px}
.row .chev{color:var(--sec30);font-size:17px;font-weight:600;margin-left:6px}
.icon-sq{width:36px;height:36px;border-radius:11px;display:flex;align-items:center;justify-content:center;flex-shrink:0;
  color:var(--label);background:var(--glass2);border:1px solid var(--stroke);
  backdrop-filter:blur(10px);box-shadow:inset 0 1px 0 rgba(255,255,255,.95),0 3px 8px rgba(40,60,110,.1)}
.r-title{font-size:17px}
.r-sub{font-size:13px;color:var(--sec60);margin-top:1px}
.r-val{margin-left:auto;text-align:right}
.r-val .v{font-size:17px;font-weight:700}
.r-val .d{font-size:13px;margin-top:1px;font-weight:600}
.pos{color:var(--green)}.neg{color:var(--red)}.mut{color:var(--sec60)}
.hero{padding:22px 18px}
.hero .cap{font-size:13px;font-weight:700;color:var(--sec60);text-transform:uppercase;letter-spacing:.05em}
.hero .big{font-size:clamp(30px,8.5vw,40px);font-weight:800;letter-spacing:-.02em;margin:3px 0}
@media(min-width:1024px){.hero .big{font-size:44px}}
.hero .chg{font-size:15px;font-weight:600}
.seg{display:flex;background:rgba(120,120,128,.14);border-radius:12px;padding:3px;margin:14px 0 4px;backdrop-filter:blur(8px)}
.seg button{flex:1;border:none;background:transparent;padding:10px 0;min-height:40px;border-radius:9px;font-size:13px;font-weight:600;color:var(--label);cursor:pointer;font-family:inherit}
.seg button.on{background:var(--segOn);box-shadow:0 2px 8px rgba(0,0,0,.16),inset 0 1px 0 rgba(255,255,255,.35)}
.btn{display:flex;align-items:center;justify-content:center;gap:8px;width:100%;padding:16px;min-height:52px;border:none;border-radius:18px;font-size:17px;font-weight:700;cursor:pointer;font-family:inherit;position:relative}
.btn-blue{color:#fff;background:linear-gradient(180deg,#2E96FF,#0071E8);
  box-shadow:0 10px 26px rgba(0,113,232,.35), inset 0 1.5px 0 rgba(255,255,255,.5), inset 0 -1px 0 rgba(0,0,0,.12)}
.btn-blue:active{transform:scale(.985)}
.btn-glass{background:var(--glass);color:var(--blue);border:1px solid var(--stroke);backdrop-filter:blur(20px) saturate(180%);-webkit-backdrop-filter:blur(20px) saturate(180%);box-shadow:0 8px 22px rgba(40,60,110,.14), inset 0 1px 0 rgba(255,255,255,.28)}
.stats{display:grid;grid-template-columns:1fr 1fr;gap:12px}
.stats.wide4{grid-template-columns:1fr 1fr}
@media(min-width:1024px){.stats.wide4{grid-template-columns:repeat(4,1fr)}}
.stat{background:var(--glass);border-radius:20px;padding:15px 16px;border:1px solid var(--stroke);backdrop-filter:blur(24px) saturate(180%);-webkit-backdrop-filter:blur(24px) saturate(180%);box-shadow:var(--cardShadow)}
.stat .k{font-size:12px;font-weight:700;color:var(--sec60);text-transform:uppercase;letter-spacing:.04em;display:flex;align-items:center;gap:5px}
.stat .v{font-size:21px;font-weight:750;margin-top:4px;letter-spacing:-.01em}
.stat .s{font-size:12px;color:var(--sec60);margin-top:2px}
.bar{height:7px;background:rgba(120,120,128,.18);border-radius:99px;overflow:hidden}
.bar>div{height:100%;border-radius:99px;transition:width .5s cubic-bezier(.2,.8,.2,1);box-shadow:inset 0 1px 0 rgba(255,255,255,.4)}
input.inp,select.inp{width:100%;background:var(--inpBg);border:1px solid var(--stroke);border-radius:14px;padding:13px 15px;color:var(--label);font-size:17px;font-family:inherit;appearance:none;backdrop-filter:blur(10px);box-shadow:inset 0 1px 3px rgba(0,0,0,.05)}
input.inp:focus{outline:2.5px solid var(--blue);outline-offset:-1px}
label.fld{display:block;font-size:13px;font-weight:700;color:var(--sec60);margin:15px 4px 6px;text-transform:uppercase;letter-spacing:.04em}
.tabbar{position:fixed;bottom:calc(14px + env(safe-area-inset-bottom));left:50%;transform:translateX(-50%);width:calc(100% - 24px);max-width:560px;
  background:var(--tabbarBg);backdrop-filter:blur(28px) saturate(200%);-webkit-backdrop-filter:blur(28px) saturate(200%);
  border:1px solid var(--stroke);border-radius:28px;display:flex;z-index:30;padding:6px;
  box-shadow:0 16px 44px rgba(40,60,110,.22), inset 0 1.5px 0 rgba(255,255,255,.95)}
.tabbar button{flex:1;border:none;background:none;padding:9px 0 7px;min-height:54px;display:flex;flex-direction:column;align-items:center;gap:3px;font-size:10px;font-weight:600;color:var(--sec60);cursor:pointer;font-family:inherit;border-radius:22px}
.tabbar button.on{color:var(--blue);background:rgba(0,122,255,.13);box-shadow:inset 0 1px 0 rgba(255,255,255,.6)}
.tabbar svg{width:25px;height:25px}
@media(min-width:1024px){.tabbar{max-width:640px;bottom:18px}.tabbar button{font-size:11px}}
.sheet-bg{position:fixed;inset:0;background:rgba(30,40,60,.35);backdrop-filter:blur(6px);-webkit-backdrop-filter:blur(6px);z-index:40;display:flex;align-items:flex-end;justify-content:center;animation:fadein .2s}
@media(min-width:560px){.sheet-bg{align-items:center}}
@keyframes fadein{from{opacity:0}to{opacity:1}}
@keyframes slideup{from{transform:translateY(44px);opacity:.6}to{transform:translateY(0);opacity:1}}
.sheet{background:var(--sheetBg);backdrop-filter:blur(34px) saturate(200%);-webkit-backdrop-filter:blur(34px) saturate(200%);
  border:1px solid var(--stroke);border-radius:26px 26px 0 0;width:100%;max-width:560px;max-height:90vh;overflow-y:auto;padding:8px 16px 26px;animation:slideup .28s cubic-bezier(.2,.8,.2,1);
  box-shadow:0 -10px 50px rgba(40,60,110,.25), inset 0 1.5px 0 rgba(255,255,255,.95)}
@media(min-width:560px){.sheet{border-radius:26px}}
.grab{width:38px;height:5px;background:var(--sec30);border-radius:99px;margin:8px auto 10px}
.sheet-head{display:flex;align-items:center;justify-content:space-between;padding:6px 0 14px}
.sheet-head .t{font-size:20px;font-weight:750}
.sheet-head button{border:none;background:none;color:var(--blue);font-size:17px;font-weight:600;cursor:pointer;font-family:inherit;padding:4px}
.toast{position:fixed;top:16px;left:50%;transform:translateX(-50%);background:var(--toastBg);backdrop-filter:blur(20px) saturate(180%);border:1px solid var(--stroke);color:var(--label);font-size:15px;font-weight:700;padding:12px 22px;border-radius:99px;z-index:60;animation:slideup .25s;box-shadow:0 12px 34px rgba(40,60,110,.2)}
.tblwrap{overflow-x:auto;margin:0 -18px;padding:0 18px}
table.tb{border-collapse:collapse;width:100%;font-size:13px;min-width:840px}
table.tb th{color:var(--sec60);font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:.05em;padding:9px 7px;text-align:right;border-bottom:1px solid var(--sep)}
table.tb th:first-child{text-align:left}
table.tb td{padding:9px 7px;text-align:right;border-bottom:1px solid var(--sep);white-space:nowrap;font-variant-numeric:tabular-nums;font-size:13px}
table.tb td:first-child{text-align:left;font-weight:600}
table.tb tr:last-child td{border-bottom:none}
td.cell{cursor:pointer;color:var(--blue)}
td.zero{color:var(--sec30)}
td.over{color:var(--red);font-weight:700}
tr.tot td{font-weight:750;border-top:2px solid var(--sep)}
.chipbar{display:flex;gap:8px;overflow-x:auto;padding:2px 2px 10px;scrollbar-width:none}
.chipbar::-webkit-scrollbar{display:none}
.chip{padding:10px 16px;min-height:42px;border-radius:99px;background:var(--glass2);border:1px solid var(--stroke);font-size:14px;font-weight:650;color:var(--label);cursor:pointer;white-space:nowrap;font-family:inherit;display:flex;align-items:center;gap:6px;backdrop-filter:blur(14px);box-shadow:inset 0 1px 0 rgba(255,255,255,.8)}
.chip.on{background:var(--label);color:#fff;border-color:transparent}
.empty{color:var(--sec60);font-size:15px;text-align:center;padding:30px 16px}
.upd-item{background:var(--updBg);border:1px solid var(--stroke);border-radius:18px;padding:13px 14px;margin-bottom:10px;box-shadow:inset 0 1px 0 rgba(255,255,255,.85)}
.upd-top{display:flex;align-items:center;gap:10px;margin-bottom:9px}
.upd-top .n{font-weight:650;font-size:15px}
.upd-top .a{margin-left:auto;font-size:13px;color:var(--sec60)}
.link{color:var(--blue);background:none;border:none;font-size:15px;font-weight:650;cursor:pointer;font-family:inherit;padding:8px 6px;margin:-8px -6px;border-radius:8px}
.link:active{background:rgba(0,122,255,.12)}
.link.red{color:var(--red)}
.footer-note{text-align:center;font-size:12px;color:var(--sec30);padding:26px 0 8px}
.sync{display:inline-flex;align-items:center;gap:6px;font-size:12px;font-weight:700;color:var(--green);background:rgba(52,199,89,.14);border:1px solid rgba(52,199,89,.25);border-radius:99px;padding:4px 11px;margin-top:8px}
.warn{display:flex;gap:12px;align-items:center;padding:14px 16px;border-radius:18px;background:var(--amberBg);border:1px solid var(--amberLn);font-size:14px;font-weight:600;color:var(--amber);margin-top:12px}
.dia-row{display:flex;align-items:center;gap:10px;padding:13px 18px;min-height:56px;position:relative;cursor:pointer}
.dia-row:active{background:var(--rowActive)}
.dia-row+.dia-row::before{content:"";position:absolute;top:0;left:64px;right:0;height:1px;background:var(--sep)}
.dia-badge{width:40px;text-align:center;flex-shrink:0}
.dia-badge .dn{font-size:17px;font-weight:750;line-height:1.1}
.dia-badge .dw{font-size:10px;font-weight:700;text-transform:uppercase;color:var(--sec60)}
.dia-badge.hoje .dn{color:var(--blue)}
.dia-mov{font-size:13px;font-weight:650;display:flex;gap:8px}
.dia-saldo{margin-left:auto;text-align:right}
.dia-saldo .v{font-size:15px;font-weight:700}
.dia-saldo .t{font-size:11px;color:var(--sec60)}
.est{opacity:.68}


/* Gráficos: no celular ganham largura mínima e rolagem lateral suave */
.chartwrap{overflow-x:auto;-webkit-overflow-scrolling:touch;margin:0 -18px;padding:0 18px;scrollbar-width:none}
.chartwrap::-webkit-scrollbar{display:none}
.chartwrap svg{min-width:660px;height:auto}
.scrollhint{display:block;text-align:center;font-size:11.5px;color:var(--sec60);font-weight:600;padding-top:6px}
@media(min-width:700px){.chartwrap{overflow:visible;margin:0;padding:0}.chartwrap svg{min-width:0}.scrollhint{display:none}}
/* Tabela de custos: desktop cabe inteira, sem rolagem lateral */
@media(min-width:1024px){
  .tblwrap{overflow:visible;margin:0;padding:0}
  table.tb{min-width:0;width:100%}
  table.tb th{padding:8px 4px;font-size:10.5px}
  table.tb td{padding:8px 4px;font-size:12px}
}
.stack>.section-h:first-child{margin-top:8px}


@keyframes tabin{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:none}}
.tabin{animation:tabin .32s cubic-bezier(.2,.8,.2,1)}
@media(prefers-reduced-motion:reduce){.tabin{animation:none}}
@media(hover:hover){
  .row:hover,.dia-row:hover{background:var(--rowActive)}
  .chip:hover{border-color:var(--blue)}
  .tabbar button:hover{color:var(--blue)}
  .link:hover{opacity:.75}
  .btn:hover{filter:brightness(1.05)}
  td.cell:hover{background:var(--rowActive)}
}
button:focus-visible,a:focus-visible{outline:2.5px solid var(--blue);outline-offset:2px}
.temabtn{width:42px;height:42px;border-radius:99px;border:1px solid var(--stroke);background:var(--glass2);
  backdrop-filter:blur(14px) saturate(180%);-webkit-backdrop-filter:blur(14px) saturate(180%);
  color:var(--label);display:flex;align-items:center;justify-content:center;cursor:pointer;flex-shrink:0;
  box-shadow:inset 0 1px 0 rgba(255,255,255,.35),0 4px 12px rgba(0,0,0,.14)}
.temabtn svg{width:20px;height:20px}
.app,.card,.stat,.sheet,.tabbar,.chip,input.inp,select.inp,.icon-sq,.temabtn{transition:background .35s,border-color .35s,color .35s,box-shadow .35s}
`;


// ---------- Ícones das caixinhas (traço único, estilo SF Symbols) ----------
const CX_PATHS = {
  shield: "M12 3l7 3v5c0 4.5-3 8.2-7 10-4-1.8-7-5.5-7-10V6l7-3z",
  hammer: "M14 4l6 6-2.2 2.2-1.4-1.4L8 19.2 4.8 16l8.4-8.4-1.4-1.4L14 4z",
  chart: "M4 19h16M6.5 15.5l3.5-4.5 3 2.5 4.5-6",
  beach: "M4 19h16M12 19V9M12 9C9 5.5 5.5 5.5 4 8c2-.5 5-.2 8 1zM12 9c3-3.5 6.5-3.5 8-1-2-.5-5-.2-8 1z",
  coffee: "M5 9h11v6a4 4 0 01-4 4H9a4 4 0 01-4-4V9zM16 10h1.5a2.5 2.5 0 010 5H16M8 5.5V4M11 5.5V4",
  bank: "M4 10h16M5 10v7M9.7 10v7M14.3 10v7M19 10v7M3.5 17h17M12 3.5L20 8H4l8-4.5z",
  cash: "M3.5 7h17v10h-17V7zM12 14.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5zM6 10v.01M18 14v.01",
  wallet: "M4 7.5A2.5 2.5 0 016.5 5H18v3M4 7.5V17a2 2 0 002 2h13a1 1 0 001-1V9a1 1 0 00-1-1H6.5A2.5 2.5 0 014 7.5zM15.5 13.5h.01",
  plane: "M10.5 13.5L4 11l1.5-1.5 5.5.5 4-4.5c.8-.8 2-.8 2.5-.3s.5 1.7-.3 2.5l-4.5 4 .5 5.5L11.5 19l-1-5.5z",
  car: "M5 16v2M19 16v2M4 11l1.5-4.5A2 2 0 017.4 5h9.2a2 2 0 011.9 1.5L20 11M4 11h16v5H4v-5zM7 13.5h.01M17 13.5h.01",
  home: "M4 10.5L12 4l8 6.5M6 9.5V19h4v-5h4v5h4V9.5",
  ring: "M12 21a6 6 0 100-12 6 6 0 000 12zM9.5 6L8 3.5h8L14.5 6",
  gift: "M4 10h16v3H4v-3zM5.5 13H18.5V20H5.5v-7zM12 10v10M12 10c-2 0-4.5-.7-4.5-2.7S10 4.5 12 7c2-2.5 4.5-1.7 4.5.3S14 10 12 10z",
  phone: "M8 3.5h8a1.5 1.5 0 011.5 1.5v14a1.5 1.5 0 01-1.5 1.5H8A1.5 1.5 0 016.5 19V5A1.5 1.5 0 018 3.5zM11 17.5h2",
  grad: "M12 4L2.5 8.5 12 13l9.5-4.5L12 4zM6 10.8V16c0 1.5 2.7 3 6 3s6-1.5 6-3v-5.2M21.5 9v5",
  health: "M12 20s-7-4.2-7-9.5A4 4 0 0112 8a4 4 0 017 2.5C19 15.8 12 20 12 20zM12 10.5v4M10 12.5h4",
  trophy: "M8 4h8v5a4 4 0 01-8 0V4zM8 5.5H5.5a2.5 2.5 0 002.7 4M16 5.5h2.5a2.5 2.5 0 01-2.7 4M12 13v3.5M8.5 20h7M10 16.5h4",
  down: "M4 8l5 5 3-3 6.5 6.5M18.5 12v4.5H14",
};
function CxIcon({ id, size = 19 }) {
  const d = CX_PATHS[id] || CX_PATHS.wallet;
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" aria-hidden>
      <path d={d} stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

// ---------- Campo de dinheiro com máscara R$ ----------
function fmtCents(raw) {
  const d = String(raw || "").replace(/\D/g, "");
  if (!d) return "";
  return (parseInt(d, 10) / 100).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
}
function MoneyInput({ inicial, onValor, autoFocus, placeholder = "R$ 0,00", style }) {
  const [raw, setRaw] = useState(() => (inicial != null && inicial !== "" && !isNaN(Number(inicial)) ? String(Math.round(Number(inicial) * 100)) : ""));
  const aoDigitar = (e) => {
    const r = e.target.value.replace(/\D/g, "");
    setRaw(r);
    onValor(r ? parseInt(r, 10) / 100 : NaN);
  };
  return (
    <input className="inp num" type="text" inputMode="numeric" autoFocus={autoFocus} placeholder={placeholder} style={style}
      value={fmtCents(raw)} onChange={aoDigitar} />
  );
}

// ---------- Campo calculadora (aceita 468+32-10 como numa planilha) ----------
function calcular(expr) {
  if (expr == null) return NaN;
  let s = String(expr).trim().replace(/R\$\s?/g, "").replace(/\s/g, "");
  if (!s) return NaN;
  s = s.replace(/\.(?=\d{3}(\D|$))/g, "");   // remove pontos de milhar
  s = s.replace(/,/g, ".");                      // vírgula decimal
  if (!/^[0-9+\-*/().]+$/.test(s)) return NaN;
  try { const v = Function('"use strict";return (' + s + ")")(); return typeof v === "number" && isFinite(v) ? v : NaN; } catch { return NaN; }
}

// ---------- Ícones da barra de abas (traço estilo SF Symbols) ----------
const Ic = {
  home: (f) => <svg viewBox="0 0 24 24" fill="none"><path d="M3 10.5 12 3l9 7.5" stroke="currentColor" strokeWidth={f ? 2.2 : 1.7} strokeLinecap="round" strokeLinejoin="round"/><path d="M5 9.5V20a1 1 0 0 0 1 1h4v-6h4v6h4a1 1 0 0 0 1-1V9.5" stroke="currentColor" strokeWidth={f ? 2.2 : 1.7} strokeLinecap="round" strokeLinejoin="round" fill={f ? "currentColor" : "none"} fillOpacity={f ? .15 : 0}/></svg>,
  box: (f) => <svg viewBox="0 0 24 24" fill="none"><rect x="3.5" y="7" width="17" height="13" rx="2.5" stroke="currentColor" strokeWidth={f ? 2.2 : 1.7} fill={f ? "currentColor" : "none"} fillOpacity={f ? .15 : 0}/><path d="M3.5 11h17M8 7V5.5A1.5 1.5 0 0 1 9.5 4h5A1.5 1.5 0 0 1 16 5.5V7" stroke="currentColor" strokeWidth={f ? 2.2 : 1.7} strokeLinecap="round"/></svg>,
  chart: (f) => <svg viewBox="0 0 24 24" fill="none"><path d="M4 19.5h16" stroke="currentColor" strokeWidth={f ? 2.2 : 1.7} strokeLinecap="round"/><path d="M5 15l4-5 4 3 6-8" stroke="currentColor" strokeWidth={f ? 2.4 : 1.9} strokeLinecap="round" strokeLinejoin="round"/><circle cx="19" cy="5" r={f ? 2.4 : 1.9} fill="currentColor"/></svg>,
  card: (f) => <svg viewBox="0 0 24 24" fill="none"><rect x="3" y="5.5" width="18" height="13" rx="2.5" stroke="currentColor" strokeWidth={f ? 2.2 : 1.7} fill={f ? "currentColor" : "none"} fillOpacity={f ? .15 : 0}/><path d="M3 10h18" stroke="currentColor" strokeWidth={f ? 2.6 : 2}/><path d="M6.5 14.5h4" stroke="currentColor" strokeWidth={f ? 2.2 : 1.7} strokeLinecap="round"/></svg>,
  cal: (f) => <svg viewBox="0 0 24 24" fill="none"><rect x="3.5" y="5" width="17" height="15.5" rx="2.5" stroke="currentColor" strokeWidth={f ? 2.2 : 1.7} fill={f ? "currentColor" : "none"} fillOpacity={f ? .15 : 0}/><path d="M3.5 9.5h17M8 3v3.5M16 3v3.5" stroke="currentColor" strokeWidth={f ? 2.2 : 1.7} strokeLinecap="round"/><circle cx="12" cy="14.5" r={f ? 1.9 : 1.5} fill="currentColor"/></svg>,
  target: (f) => <svg viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="8.5" stroke="currentColor" strokeWidth={f ? 2.2 : 1.7} fill={f ? "currentColor" : "none"} fillOpacity={f ? .13 : 0}/><circle cx="12" cy="12" r="4.5" stroke="currentColor" strokeWidth={f ? 2.2 : 1.7}/><circle cx="12" cy="12" r={f ? 1.8 : 1.4} fill="currentColor"/></svg>,
  clock: (f) => <svg viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="8.5" stroke="currentColor" strokeWidth={f ? 2.2 : 1.7} fill={f ? "currentColor" : "none"} fillOpacity={f ? .15 : 0}/><path d="M12 7.5V12l3 2" stroke="currentColor" strokeWidth={f ? 2.2 : 1.7} strokeLinecap="round" strokeLinejoin="round"/></svg>,
};

// ---------- Gráficos SVG ----------
function LineChart({ points, cor = "#007AFF", altura = 150, mostraDatas = true, formatoY = fmtShort }) {
  const [sel, setSel] = useState(null);
  if (!points || points.length < 2) return <div className="empty">O gráfico aparece a partir da segunda atualização.</div>;
  const w = 600, h = altura, pl = 8, pr = 8, pt = 14, pb = mostraDatas ? 22 : 8;
  const vals = points.map((p) => p.total);
  const min = Math.min(...vals), max = Math.max(...vals);
  const range = max - min || 1;
  const X = (i) => pl + (i * (w - pl - pr)) / (points.length - 1);
  const Y = (v) => pt + (h - pt - pb) - ((v - min) * (h - pt - pb)) / range;
  const d = points.map((p, i) => `${i === 0 ? "M" : "L"}${X(i).toFixed(1)},${Y(p.total).toFixed(1)}`).join(" ");
  const subiu = vals[vals.length - 1] >= vals[0];
  const c = subiu ? "#34C759" : "#FF3B30";
  const gid = "g" + Math.round(min);
  const onMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    const cx = ((e.touches ? e.touches[0].clientX : e.clientX) - r.left) / r.width * w;
    let best = 0, bd = Infinity;
    points.forEach((_, i) => { const dd = Math.abs(X(i) - cx); if (dd < bd) { bd = dd; best = i; } });
    setSel(best);
  };
  return (
    <div>
      {sel != null && (
        <div style={{ display: "flex", justifyContent: "space-between", fontSize: 13, fontWeight: 600, marginBottom: 4 }}>
          <span className="mut">{fmtData(points[sel].data)}</span>
          <span className="num">{fmt(points[sel].total)}</span>
        </div>
      )}
      <svg viewBox={`0 0 ${w} ${h}`} style={{ width: "100%", height: "auto", display: "block", touchAction: "pan-y" }}
        onMouseMove={onMove} onMouseLeave={() => setSel(null)} onTouchMove={onMove} onTouchEnd={() => setSel(null)}>
        <defs>
          <linearGradient id={gid} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor={c} stopOpacity=".22" />
            <stop offset="100%" stopColor={c} stopOpacity="0" />
          </linearGradient>
        </defs>
        <path d={`${d} L${X(points.length - 1)},${h - pb} L${X(0)},${h - pb} Z`} fill={`url(#${gid})`} />
        <path d={d} fill="none" stroke={c} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
        {sel != null && (<>
          <line x1={X(sel)} x2={X(sel)} y1={pt - 4} y2={h - pb} stroke="currentColor" opacity=".3" strokeWidth="1" />
          <circle cx={X(sel)} cy={Y(points[sel].total)} r="5" fill={c} stroke="#fff" strokeWidth="2" />
        </>)}
        {mostraDatas && (<>
          <text x={pl} y={h - 6} fontSize="11.5" fontWeight="600" fill="currentColor" opacity=".6">{fmtData(points[0].data)}</text>
          <text x={w - pr} y={h - 6} fontSize="11.5" fontWeight="600" fill="currentColor" opacity=".6" textAnchor="end">{fmtData(points[points.length - 1].data)}</text>
        </>)}
      </svg>
    </div>
  );
}

function Donut({ itens, total }) {
  const R = 15.915;
  let acc = 0;
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 18 }}>
      <svg viewBox="0 0 42 42" style={{ width: 130, height: 130, flexShrink: 0 }}>
        <circle cx="21" cy="21" r={R} fill="none" stroke="currentColor" strokeOpacity=".14" strokeWidth="5" />
        {itens.map((it, i) => {
          const pct = total > 0 ? (it.valor / total) * 100 : 0;
          const el = (
            <circle key={i} cx="21" cy="21" r={R} fill="none" stroke={it.cor} strokeWidth="5"
              strokeDasharray={`${Math.max(pct - 1, 0)} ${100 - Math.max(pct - 1, 0)}`}
              strokeDashoffset={-acc + 25} strokeLinecap="round" />
          );
          acc += pct;
          return el;
        })}
        <text x="21" y="20" textAnchor="middle" fontSize="5.4" fontWeight="700" fill="currentColor">{fmtShort(total).replace("R$ ", "")}</text>
        <text x="21" y="26" textAnchor="middle" fontSize="3.2" fill="currentColor" opacity=".55">total</text>
      </svg>
      <div style={{ flex: 1 }}>
        {itens.slice(0, 7).map((it, i) => (
          <div key={i} style={{ display: "flex", alignItems: "center", gap: 7, fontSize: 13, padding: "3px 0" }}>
            <span className="legend dot" style={{ width: 9, height: 9, borderRadius: 99, background: it.cor, flexShrink: 0 }} />
            <span style={{ color: "var(--sec)" }}>{it.nome}</span>
            <span className="num" style={{ marginLeft: "auto", fontWeight: 600 }}>{total > 0 ? Math.round((it.valor / total) * 100) : 0}%</span>
          </div>
        ))}
      </div>
    </div>
  );
}

function Bars({ labels, series, cores, formatoY = fmtShort, onBarClick, sel }) {
  const w = 600, h = 185, pb = 26, pt = 28, bw = (w / labels.length) * 0.62;
  const maxV = Math.max(...series.flat(), 1);
  return (
    <svg viewBox={`0 0 ${w} ${h}`} style={{ width: "100%", height: "auto", display: "block" }}>
      {labels.map((l, i) => {
        const cx = (i + 0.5) * (w / labels.length);
        return (
          <g key={i} onClick={() => onBarClick && onBarClick(i)} style={{ cursor: onBarClick ? "pointer" : "default" }}>
            {sel === i && <rect x={cx - bw / 2 - 6} y={6} width={bw + 12} height={h - 10} rx="8" fill="currentColor" opacity=".1" />}
            {series.map((s, si) => {
              const v = s[i] || 0;
              const bh = (v / maxV) * (h - pb - pt);
              const off = series.length > 1 ? (si === 0 ? -bw * 0.27 : bw * 0.27) : 0;
              const ww = series.length > 1 ? bw * 0.45 : bw;
              return <rect key={si} x={cx + off - ww / 2} y={h - pb - bh} width={ww} height={Math.max(bh, v > 0 ? 3 : 0)} rx="3.5" fill={cores[si]} opacity={si === 0 ? 1 : 0.35} />;
            })}
            <text x={cx} y={h - 7} textAnchor="middle" fontSize="12.5" fontWeight="600" fill="currentColor" opacity=".68">{l}</text>
            {series[0][i] > 0 && <text x={cx} y={h - pb - (series[0][i] / maxV) * (h - pb - pt) - 6} textAnchor="middle" fontSize="11" fontWeight="700" fill="currentColor" opacity=".75">{formatoY(series[0][i]).replace("R$ ", "")}</text>}
          </g>
        );
      })}
    </svg>
  );
}

function Sheet({ title, onClose, action, children }) {
  return (
    <div className="sheet-bg" onClick={onClose}>
      <div className="sheet" onClick={(e) => e.stopPropagation()}>
        <div className="grab" />
        <div className="sheet-head">
          <button onClick={onClose}>Fechar</button>
          <span className="t">{title}</span>
          <span style={{ width: 52, textAlign: "right" }}>{action || ""}</span>
        </div>
        {children}
      </div>
    </div>
  );
}

// ============================================================
export default function ControleFinanceiro() {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [user, setUser] = useState(null);
  const [novo, setNovo] = useState(false);
  const [codigo, setCodigo] = useState("");
  const saveTimer = useRef(null);
  const [tab, setTab] = useState("resumo");
  const [modal, setModal] = useState(null);
  const [toast, setToast] = useState(null);
  const [periodo, setPeriodo] = useState("1M");
  const [sysDark, setSysDark] = useState(() => typeof window !== "undefined" && window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches);
  const [anoCustos, setAnoCustos] = useState(new Date().getFullYear());
  const [mesSel, setMesSel] = useState(new Date().getMonth());

  useEffect(() => {
    const metasIos = [
      ["viewport", "width=device-width, initial-scale=1, viewport-fit=cover"],
      ["theme-color", "#EAF1FB"],
      ["apple-mobile-web-app-capable", "yes"],
      ["apple-mobile-web-app-status-bar-style", "black-translucent"],
    ];
    metasIos.forEach(([name, content]) => {
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) { el = document.createElement("meta"); el.name = name; document.head.appendChild(el); }
      el.content = content;
    });
    (async () => {
      const { data: { session } } = await supabase.auth.getSession();
      setUser(session?.user || null);
      const saved = await loadData();
      if (saved) setData(migrar(saved));
      else setNovo(true);
    })();
  }, []);

  useEffect(() => {
    if (!window.matchMedia) return;
    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    const fn = (e) => setSysDark(e.matches);
    if (mq.addEventListener) mq.addEventListener("change", fn); else mq.addListener(fn);
    return () => { if (mq.removeEventListener) mq.removeEventListener("change", fn); else mq.removeListener(fn); };
  }, []);

  const persist = (next) => {
    setData(next);
    if (saveTimer.current) clearTimeout(saveTimer.current);
    saveTimer.current = setTimeout(() => saveData(next), 900);
  };

  const comecar = (semente) => {
    const d = JSON.parse(JSON.stringify(semente));
    setData(d); setNovo(false); saveData(d);
  };

  const sair = async () => { await supabase.auth.signOut(); navigate("/"); };
  const showToast = (m) => { setToast(m); setTimeout(() => setToast(null), 2400); };

  // ---------- Derivados ----------
  const tema = data?.tema || "auto";
  const temaEfetivo = tema === "claro" ? "light" : tema === "escuro" ? "dark" : sysDark ? "dark" : "light";
  useEffect(() => {
    const el = document.querySelector('meta[name="theme-color"]');
    if (el) el.content = temaEfetivo === "dark" ? "#0B0F16" : "#EAF1FB";
  }, [temaEfetivo]);
  const trocarTema = () => {
    const ordem = { auto: "claro", claro: "escuro", escuro: "auto" };
    const novoTema = ordem[tema];
    const next = { ...data, tema: novoTema };
    persist(next);
    showToast("Tema " + (novoTema === "auto" ? "automático" : novoTema));
  };

  const total = useMemo(() => (data ? data.caixinhas.reduce((s, c) => s + c.valor, 0) : 0), [data]);

  const snapshotsFiltrados = useMemo(() => {
    if (!data) return [];
    const dias = { "7D": 7, "1M": 30, "3M": 91, "6M": 182, "1A": 365 }[periodo];
    if (!dias) return data.snapshots;
    const corte = addDias(hoje(), -dias);
    const f = data.snapshots.filter((s) => s.data >= corte);
    return f.length >= 2 ? f : data.snapshots.slice(-2);
  }, [data, periodo]);

  const variacaoPeriodo = useMemo(() => {
    if (snapshotsFiltrados.length < 2) return null;
    const a = snapshotsFiltrados[0].total, b = snapshotsFiltrados[snapshotsFiltrados.length - 1].total;
    return { abs: b - a, pct: a !== 0 ? ((b - a) / a) * 100 : 0 };
  }, [snapshotsFiltrados]);

  const variacaoHoje = useMemo(() => {
    if (!data) return 0;
    return data.historico.filter((h) => h.data === hoje()).reduce((s, h) => s + (h.novo - h.anterior), 0);
  }, [data]);

  const ultimaAtualizacao = useMemo(() => {
    if (!data || !data.historico.length) return null;
    return data.historico[data.historico.length - 1].data;
  }, [data]);

  const diasAtualizados = useMemo(() => (data ? new Set(data.historico.map((h) => h.data)).size : 0), [data]);

  const historicoPorDia = useMemo(() => {
    const map = {};
    (data?.historico || []).forEach((h) => { if (!map[h.data]) map[h.data] = []; map[h.data].push(h); });
    return Object.entries(map).sort((a, b) => (a[0] < b[0] ? 1 : -1));
  }, [data]);

  const serieCaixinha = useMemo(() => {
    const out = {};
    if (!data) return out;
    data.caixinhas.forEach((c) => {
      const evs = data.historico.filter((h) => h.caixinha === c.nome);
      const pts = [];
      if (evs.length) { pts.push({ data: evs[0].data, total: evs[0].anterior }); evs.forEach((e) => pts.push({ data: e.data, total: e.novo })); }
      out[c.id] = pts;
    });
    return out;
  }, [data]);

  // Fluxo: dias calculados até 90 dias à frente
  const fluxoDias = useMemo(() => (data ? calcularFluxo(data.fluxo, data.caixinhas, addDias(hoje(), 92)) : []), [data]);
  const saldoFluxoHoje = useMemo(() => {
    const d = fluxoDias.find((x) => x.data === hoje());
    return d ? d.saldo : null;
  }, [fluxoDias]);
  const somaCaixinhasFluxo = useMemo(
    () => (data ? data.caixinhas.filter((c) => c.noFluxo).reduce((s, c) => s + c.valor, 0) : 0),
    [data]
  );

  if (novo && !data)
    return (
      <div className="app" data-theme={temaEfetivo}><style>{CSS}</style>
        <div className="blobs"><div className="blob b1"/><div className="blob b2"/><div className="blob b3"/></div>
        <div className="wrap" style={{ maxWidth: 480, paddingTop: 70 }}>
          <div style={{ textAlign: "center", marginBottom: 22 }}>
            <Wordmark size={20} />
            <div className="lt" style={{ paddingTop: 14 }}>Bem-vindo!</div>
            <div className="lt-sub">Vamos deixar tudo pronto.</div>
          </div>
          <div className="card pad">
            <button className="btn btn-blue" onClick={() => comecar(seedNovo())}>Começar do zero</button>
            <div style={{ textAlign: "center", fontSize: 13, color: "var(--sec60)", margin: "16px 0 8px", fontWeight: 600 }}>Tem um código de importação?</div>
            <input className="inp" placeholder="Código" value={codigo} onChange={(e) => setCodigo(e.target.value)} />
            <button className="btn btn-glass" style={{ marginTop: 10 }} disabled={codigo.trim().toUpperCase() !== "LUIS2026"}
              onClick={() => { if (codigo.trim().toUpperCase() === "LUIS2026") comecar(SEED); }}>
              Importar meus dados
            </button>
          </div>
        </div>
      </div>
    );

  if (!data)
    return <div className="app" data-theme={temaEfetivo}><style>{CSS}</style><div className="wrap"><div className="empty" style={{ paddingTop: 100 }}>Carregando…</div></div></div>;

  const anoAtual = new Date().getFullYear();
  const mesAtual = new Date().getMonth();
  const custosAno = data.custos[anoCustos] || [];
  const anosDisponiveis = Object.keys(data.custos).map(Number).sort();
  const gastoMes = (data.custos[anoAtual] || []).reduce((s, c) => s + (c.meses[mesAtual] || 0), 0);
  const orcadoMes = (data.custos[anoAtual] || []).reduce((s, c) => s + (c.orcado || 0), 0);
  const anoMeta = data.caixinhas.some((c) => c.metas && c.metas[anoAtual]) ? anoAtual : anoAtual + 1;

  // ---------- Ações ----------
  // Atualiza o retrato do patrimônio do dia e salva
  const finalizar = (next) => {
    const t = next.caixinhas.reduce((s, c) => s + c.valor, 0);
    const i = next.snapshots.findIndex((s) => s.data === hoje());
    if (i >= 0) next.snapshots[i].total = t; else next.snapshots.push({ data: hoje(), total: t });
    persist(next);
  };

  const salvarAtualizacaoDiaria = (valores) => {
    const d = hoje();
    const next = JSON.parse(JSON.stringify(data));
    let mudou = false;
    next.caixinhas.forEach((c) => {
      const v = valores[c.id];
      if (v !== undefined && !isNaN(v) && Math.abs(v - c.valor) > 0.004) {
        next.historico.push({ data: d, caixinha: c.nome, anterior: c.valor, novo: v });
        c.valor = v; mudou = true;
      }
    });
    const novoTotal = next.caixinhas.reduce((s, c) => s + c.valor, 0);
    const idx = next.snapshots.findIndex((s) => s.data === d);
    if (idx >= 0) next.snapshots[idx].total = novoTotal; else next.snapshots.push({ data: d, total: novoTotal });
    persist(next); setModal(null);
    showToast(mudou ? "Dia registrado" : "Nenhuma mudança");
  };

  // Soma (ou desconta) um valor na tabela de custos, na categoria e mês do lançamento
  const aplicarNoCusto = (next, categoria, dataISO, valor) => {
    if (!categoria || !valor) return;
    const ano = parseInt(dataISO.slice(0, 4));
    const mi = parseInt(dataISO.slice(5, 7)) - 1;
    if (!next.custos[ano]) {
      const base = next.custos[Math.max(...Object.keys(next.custos).map(Number))] || [];
      next.custos[ano] = base.map((c) => ({ nome: c.nome, orcado: c.orcado, meses: Array(12).fill(0) }));
    }
    let cat = next.custos[ano].find((c) => c.nome === categoria);
    if (!cat) { cat = { nome: categoria, orcado: 0, meses: Array(12).fill(0) }; next.custos[ano].push(cat); }
    cat.meses[mi] = Math.round((cat.meses[mi] + valor) * 100) / 100;
    if (cat.meses[mi] < 0) cat.meses[mi] = 0;
  };

  // Move dinheiro entre caixinhas conforme o lançamento (sinal +1 aplica, -1 desfaz).
  // "aplicado" é o estado real (já aconteceu ou não) — nunca mais se re-deriva
  // comparando datas no momento da chamada, pra editar/excluir depois não "desfazer"
  // um efeito que nunca tinha sido aplicado de verdade.
  const aplicarNasCaixinhas = (next, l, sinal) => {
    if (!l) return;
    if (sinal > 0) {
      if (l.plan && l.data > hoje()) return;   // ainda agendado pro futuro: não aplica agora
      moverSaldoCaixinhas(next, l, 1);
      l.aplicado = true;
      if (l.plan) l.plan = false;
    } else {
      if (!l.aplicado) return;                 // nunca foi de fato aplicado: não há o que desfazer
      moverSaldoCaixinhas(next, l, -1);
      l.aplicado = false;
    }
  };

  const salvarLancamento = (l, original) => {
    const next = JSON.parse(JSON.stringify(data));
    if (original) {
      if (original.categoria) aplicarNoCusto(next, original.categoria, original.data, -(original.valor || original.s || 0));
      aplicarNasCaixinhas(next, original, -1);
      const i = next.fluxo.lanc.findIndex((x) => x.data === original.data && x.valor === original.valor && x.tipo === original.tipo && x.desc === original.desc);
      if (i >= 0) next.fluxo.lanc.splice(i, 1);
    }
    next.fluxo.lanc.push(l);
    if (l.tipo === "gasto" && l.categoria) aplicarNoCusto(next, l.categoria, l.data, l.valor);
    aplicarNasCaixinhas(next, l, 1);
    next.fluxo.lanc.sort((x, y) => (x.data < y.data ? -1 : 1));
    finalizar(next);
    setModal(null);
    showToast(l.tipo === "gasto" && l.categoria ? "Lançado e somado em " + l.categoria : "Lançamento salvo");
  };

  // Recebimento com distribuição: entra numa caixinha e se reparte nas outras
  const salvarRecebimento = ({ data: dataR, valor, entrada, partes, desc }) => {
    const next = JSON.parse(JSON.stringify(data));
    const base = { data: dataR, desc: desc || undefined };
    const lEnt = { ...base, tipo: "entrada", valor, destino: entrada, e: valor, s: 0 };
    next.fluxo.lanc.push(lEnt);
    aplicarNasCaixinhas(next, lEnt, 1);
    partes.filter((p) => p.valor > 0 && p.destino !== entrada).forEach((p) => {
      const lT = { ...base, tipo: "transf", valor: p.valor, origem: entrada, destino: p.destino };
      next.fluxo.lanc.push(lT);
      aplicarNasCaixinhas(next, lT, 1);
    });
    next.fluxo.lanc.sort((x, y) => (x.data < y.data ? -1 : 1));
    finalizar(next);
    setModal(null);
    showToast("Recebimento distribuído");
  };

  const excluirLancamento = (l) => {
    const next = JSON.parse(JSON.stringify(data));
    if (l.categoria) aplicarNoCusto(next, l.categoria, l.data, -(l.valor || l.s || 0));
    aplicarNasCaixinhas(next, l, -1);
    const i = next.fluxo.lanc.findIndex((x) => x.data === l.data && x.valor === l.valor && x.tipo === l.tipo && x.desc === l.desc);
    if (i >= 0) next.fluxo.lanc.splice(i, 1);
    finalizar(next); setModal(null); showToast("Lançamento removido");
  };

  const salvarGastoDiario = (v) => {
    const next = JSON.parse(JSON.stringify(data));
    next.fluxo.gastoDiario = v;
    persist(next); setModal(null); showToast("Projeção atualizada");
  };

  const salvarCaixinha = (cx) => {
    const next = JSON.parse(JSON.stringify(data));
    if (cx.id) {
      const i = next.caixinhas.findIndex((c) => c.id === cx.id);
      if (i >= 0) {
        const nomeAntigo = next.caixinhas[i].nome;
        next.caixinhas[i] = { ...next.caixinhas[i], ...cx };
        if (cx.nome !== nomeAntigo) next.historico.forEach((h) => { if (h.caixinha === nomeAntigo) h.caixinha = cx.nome; });
      }
    } else {
      next.caixinhas.push({ id: "cx" + Date.now(), ...cx });
      const novoTotal = next.caixinhas.reduce((s, c) => s + c.valor, 0);
      const idx = next.snapshots.findIndex((s) => s.data === hoje());
      if (idx >= 0) next.snapshots[idx].total = novoTotal; else next.snapshots.push({ data: hoje(), total: novoTotal });
    }
    persist(next); setModal(null); showToast("Caixinha salva");
  };

  const excluirCaixinha = (id) => {
    const next = JSON.parse(JSON.stringify(data));
    next.caixinhas = next.caixinhas.filter((c) => c.id !== id);
    persist(next); setModal(null); showToast("Caixinha removida");
  };

  const editarCusto = (ano, ci, mi, valor) => {
    const next = JSON.parse(JSON.stringify(data));
    next.custos[ano][ci].meses[mi] = valor;
    persist(next); setModal(null);
  };
  const editarOrcado = (ano, ci, valor) => {
    const next = JSON.parse(JSON.stringify(data));
    next.custos[ano][ci].orcado = valor;
    persist(next); setModal(null);
  };
  const addCategoria = (ano, nome, orcado) => {
    const next = JSON.parse(JSON.stringify(data));
    if (!next.custos[ano]) next.custos[ano] = [];
    next.custos[ano].push({ nome, orcado: orcado || 0, meses: Array(12).fill(0) });
    persist(next); setModal(null); showToast("Categoria criada");
  };
  const renomearCategoria = (ano, ci, nome, orcado) => {
    const next = JSON.parse(JSON.stringify(data));
    next.custos[ano][ci].nome = nome;
    next.custos[ano][ci].orcado = orcado;
    persist(next); setModal(null); showToast("Categoria atualizada");
  };
  const removerCategoria = (ano, ci) => {
    const next = JSON.parse(JSON.stringify(data));
    next.custos[ano].splice(ci, 1);
    persist(next); setModal(null); showToast("Categoria removida");
  };
  const salvarMetas = (id, metas) => {
    const next = JSON.parse(JSON.stringify(data));
    const c = next.caixinhas.find((x) => x.id === id);
    if (c) c.metas = metas;
    persist(next); setModal(null); showToast("Metas atualizadas");
  };

  const criarAno = (ano) => {
    const next = JSON.parse(JSON.stringify(data));
    if (!next.custos[ano]) {
      const base = next.custos[Math.max(...anosDisponiveis)] || [];
      next.custos[ano] = base.map((c) => ({ nome: c.nome, orcado: c.orcado, meses: Array(12).fill(0) }));
    }
    persist(next); setAnoCustos(ano);
  };

  // ---------- Render ----------
  const alocacao = [...data.caixinhas].sort((a, b) => b.valor - a.valor).map((c) => ({ nome: c.nome, valor: c.valor, cor: c.cor }));

  return (
    <div className="app" data-theme={temaEfetivo}>
      <style>{CSS}</style>
      <div className="blobs"><div className="blob b1"/><div className="blob b2"/><div className="blob b3"/><div className="blob b4"/></div>
      <div className="wrap">
        <div style={{ display: "flex", alignItems: "center", gap: 10, paddingTop: 14 }}>
          <Wordmark size={14} />
          <div style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: 10 }}>
            {user?.user_metadata?.avatar_url && <img src={user.user_metadata.avatar_url} alt="" style={{ width: 30, height: 30, borderRadius: 99, border: "1.5px solid var(--stroke)" }} />}
            <button className="link" onClick={() => navigate("/configuracoes")}>Ajustes</button>
            <button className="link red" onClick={sair}>Sair</button>
          </div>
        </div>
      <div key={tab} className="tabin">

        {/* ================= RESUMO ================= */}
        {tab === "resumo" && (<>
          <div className="lt" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <span>Resumo</span>
            <button className="temabtn" onClick={trocarTema} aria-label="Trocar tema">
              {tema === "auto" ? (
                <svg viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="8.2" stroke="currentColor" strokeWidth="1.7"/><path d="M12 3.8v16.4A8.2 8.2 0 0012 3.8z" fill="currentColor"/></svg>
              ) : tema === "claro" ? (
                <svg viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="4.4" stroke="currentColor" strokeWidth="1.7"/><path d="M12 2.8v2.4M12 18.8v2.4M2.8 12h2.4M18.8 12h2.4M5.5 5.5l1.7 1.7M16.8 16.8l1.7 1.7M18.5 5.5l-1.7 1.7M7.2 16.8l-1.7 1.7" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round"/></svg>
              ) : (
                <svg viewBox="0 0 24 24" fill="none"><path d="M20 14.5A8.5 8.5 0 019.5 4 8.5 8.5 0 1020 14.5z" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/></svg>
              )}
            </button>
          </div>
          <div className="lt-sub">{fmtDataLonga(hoje())}</div>

          <div className="cols">
          <div className="stack">
          <div className="card hero">
            <div className="cap">Patrimônio total</div>
            <div className="big num">{fmt(total)}</div>
            <div className="chg">
              {variacaoHoje !== 0 ? (
                <span className={variacaoHoje > 0 ? "pos" : "neg"}>{variacaoHoje > 0 ? "▲" : "▼"} {fmt(Math.abs(variacaoHoje))} hoje</span>
              ) : ultimaAtualizacao && ultimaAtualizacao !== hoje() ? (
                <span className="mut">Última atualização {fmtData(ultimaAtualizacao)}</span>
              ) : (<span className="mut">Sem movimentos hoje</span>)}
            </div>
            <div className="seg">
              {["7D", "1M", "3M", "6M", "1A", "Tudo"].map((p) => (
                <button key={p} className={periodo === p ? "on" : ""} onClick={() => setPeriodo(p)}>{p}</button>
              ))}
            </div>
            <LineChart points={snapshotsFiltrados} />
            {variacaoPeriodo && (
              <div style={{ display: "flex", justifyContent: "space-between", marginTop: 10, fontSize: 14, fontWeight: 600 }}>
                <span className="mut">No período</span>
                <span className={variacaoPeriodo.abs >= 0 ? "pos" : "neg"}>
                  {variacaoPeriodo.abs >= 0 ? "+" : ""}{fmt(variacaoPeriodo.abs)} ({variacaoPeriodo.pct >= 0 ? "+" : ""}{variacaoPeriodo.pct.toFixed(2)}%)
                </span>
              </div>
            )}
          </div>

          <div style={{ margin: "12px 0" }}>
            <button className="btn btn-blue" onClick={() => setModal({ type: "atualizar" })}>Atualizar valores de hoje</button>
          </div>

          </div>
          <div className="stack">
          <div className="section-h">Alocação</div>
          <div className="card pad"><Donut itens={alocacao} total={total} /></div>

          <div className="section-h" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <span>Metas {anoMeta}</span>
            <button className="link" style={{ textTransform: "none", letterSpacing: 0 }} onClick={() => setTab("metas")}>Simular ›</button>
          </div>
          <div className="card">
            {data.caixinhas.filter((c) => c.metas && c.metas[anoMeta]).map((c) => {
              const meta = c.metas[anoMeta];
              const pct = Math.min(100, (c.valor / meta) * 100);
              return (
                <div key={c.id} style={{ padding: "13px 18px", borderBottom: "1px solid var(--sep)" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", fontSize: 15, fontWeight: 650, marginBottom: 7 }}>
                    <span>{c.nome}</span>
                    <span className="num" style={{ color: pct >= 100 ? "var(--green)" : "var(--label)" }}>{Math.round(pct)}%</span>
                  </div>
                  <div className="bar"><div style={{ width: pct + "%", background: c.cor }} /></div>
                  <div style={{ display: "flex", justifyContent: "space-between", fontSize: 12, color: "var(--sec60)", marginTop: 5 }}>
                    <span className="num">{fmt0(c.valor)} de {fmt0(meta)}</span>
                    <span className="num">{pct >= 100 ? "Meta atingida 🎉" : `faltam ${fmt0(meta - c.valor)}`}</span>
                  </div>
                </div>
              );
            })}
            {!data.caixinhas.some((c) => c.metas && c.metas[anoMeta]) && <div className="empty">Nenhuma meta para {anoMeta}. Defina na aba Metas.</div>}
          </div>
          </div>
          </div>
          <div className="stats wide4" style={{ marginTop: 16 }}>
            <div className="stat">
              <div className="k">💧 Saldo disponível</div>
              <div className="v num">{fmt(somaCaixinhasFluxo)}</div>
              <div className="s">Dia a dia + Conta</div>
            </div>
            <div className="stat">
              <div className="k">Registros</div>
              <div className="v num">{diasAtualizados}</div>
              <div className="s">dias atualizados</div>
            </div>
            <div className="stat">
              <div className="k">💳 Gasto em {MESES[mesAtual]}</div>
              <div className="v num">{fmt0(gastoMes)}</div>
              <div className="s">de {fmt0(orcadoMes)} orçados</div>
            </div>
            <div className="stat">
              <div className="k">{gastoMes <= orcadoMes ? "✅" : "⚠️"} Orçamento</div>
              <div className="v num" style={{ color: gastoMes <= orcadoMes ? "var(--green)" : "var(--red)" }}>
                {orcadoMes > 0 ? Math.round((gastoMes / orcadoMes) * 100) : 0}%
              </div>
              <div className="s">{gastoMes <= orcadoMes ? "dentro do planejado" : "acima do planejado"}</div>
            </div>
          </div>

          <div style={{ marginTop: 16 }}>
            <button className="btn btn-glass" onClick={() => setModal({ type: "historico" })}>Ver histórico de atualizações</button>
          </div>
          <div className="footer-note">Salvo automaticamente</div>
        </>)}

        {/* ================= CAIXINHAS ================= */}
        {tab === "caixinhas" && (<>
          <div className="lt">Caixinhas</div>
          <div className="lt-sub num">{data.caixinhas.length} caixinhas · {fmt(total)}</div>
          <button className="btn btn-blue" onClick={() => setModal({ type: "atualizar" })} style={{ marginBottom: 14, maxWidth: 480 }}>Atualizar valores de hoje</button>
          <div className="two-col-cards">
            {data.caixinhas.map((c) => {
              const evs = data.historico.filter((h) => h.caixinha === c.nome);
              const ult = evs[evs.length - 1];
              const d = ult ? ult.novo - ult.anterior : 0;
              return (
                <div className="card" key={c.id} onClick={() => setModal({ type: "detalhe", cx: c })} style={{ cursor: "pointer" }}>
                <div className="row">
                  <div className="icon-sq"><CxIcon id={c.icone} /></div>
                  <div>
                    <div className="r-title" style={{ fontWeight: 650 }}>{c.nome}{c.noFluxo && <span style={{ fontSize: 11, marginLeft: 6, color: "var(--blue)", fontWeight: 700 }}>💧 fluxo</span>}</div>
                    <div className="r-sub">{c.metas?.[anoMeta] ? `Meta ${anoMeta}: ${fmt0(c.metas[anoMeta])}` : evs.length + " movimentos"}</div>
                  </div>
                  <div className="r-val">
                    <div className="v num">{fmt(c.valor)}</div>
                    {ult && <div className={"d num " + (d > 0 ? "pos" : d < 0 ? "neg" : "mut")}>{d > 0 ? "+" : ""}{fmt(d)}</div>}
                  </div>
                  <span className="chev">›</span>
                </div>
                </div>
              );
            })}
            <button className="btn btn-glass" style={{ minHeight: 86, borderRadius: 24 }} onClick={() => setModal({ type: "editcx", cx: null })}>＋ Nova caixinha</button>
          </div>
        </>)}

        {/* ================= FLUXO DE CAIXA ================= */}
        {tab === "fluxo" && <Fluxo data={data} fluxoDias={fluxoDias} somaCaixinhas={somaCaixinhasFluxo} setModal={setModal} />}

        {/* ================= METAS ================= */}
        {tab === "metas" && <Metas data={data} setModal={setModal} />}

        {/* ================= ANÁLISE ================= */}
        {tab === "analise" && <Analise data={data} />}

        {/* ================= CUSTOS ================= */}
        {tab === "custos" && (<>
          <div className="lt">Custos</div>
                    <div className="chipbar">
            {anosDisponiveis.map((a) => (
              <button key={a} className={"chip" + (anoCustos === a ? " on" : "")} onClick={() => { setAnoCustos(a); setMesSel(a === anoAtual ? mesAtual : 0); }}>{a}</button>
            ))}
            <button className="chip" onClick={() => criarAno(Math.max(...anosDisponiveis) + 1)}>＋ {Math.max(...anosDisponiveis) + 1}</button>
          </div>
          <div className="cols">
          <div className="stack">
          <div className="card pad">
            <div style={{ fontSize: 15, fontWeight: 750, marginBottom: 4 }}>Total por mês · {anoCustos}</div>
            <div style={{ fontSize: 12, color: "var(--sec60)", marginBottom: 8 }}>Toque em um mês para detalhar. A barra clara é o orçado.</div>
            <div className="chartwrap">
            <Bars labels={MESES}
              series={[MESES.map((_, mi) => custosAno.reduce((s, c) => s + (c.meses[mi] || 0), 0)), MESES.map(() => custosAno.reduce((s, c) => s + (c.orcado || 0), 0))]}
              cores={[IOS.blue, IOS.gray]} onBarClick={setMesSel} sel={mesSel} />
            </div>
            <span className="scrollhint">arraste para os lados</span>
          </div>
          </div>
          <div className="stack">
          <div className="section-h" style={{ marginTop: 12 }}>{MESES_FULL[mesSel]} de {anoCustos}</div>
          <div className="card">
            {(() => {
              const doMes = custosAno.map((c, ci) => ({ ...c, ci, v: c.meses[mesSel] || 0 })).filter((c) => c.v > 0).sort((a, b) => b.v - a.v);
              const totMes = doMes.reduce((s, c) => s + c.v, 0);
              if (!doMes.length) return <div className="empty">Sem gastos registrados neste mês.</div>;
              return (<>
                {doMes.map((c) => (
                  <div className="row noicon" key={c.ci} onClick={() => setModal({ type: "custo", ano: anoCustos, ci: c.ci, mi: mesSel, valor: c.v, nome: c.nome })} style={{ cursor: "pointer" }}>
                    <div style={{ flex: 1 }}>
                      <div style={{ display: "flex", justifyContent: "space-between", fontSize: 15 }}>
                        <span style={{ fontWeight: 550 }}>{c.nome}</span>
                        <span className={"num " + (c.orcado && c.v > c.orcado ? "neg" : "")} style={{ fontWeight: 650 }}>{fmt(c.v)}</span>
                      </div>
                      <div className="bar" style={{ marginTop: 6 }}><div style={{ width: (totMes ? (c.v / totMes) * 100 : 0) + "%", background: c.orcado && c.v > c.orcado ? "var(--redB)" : "var(--blue)" }} /></div>
                    </div>
                  </div>
                ))}
                <div className="row noicon" style={{ fontWeight: 750 }}>
                  <span>Total</span><span className="num" style={{ marginLeft: "auto" }}>{fmt(totMes)}</span>
                </div>
              </>);
            })()}
          </div>
          </div>
          </div>
          <div className="section-h">Tabela completa</div>
          <div className="card pad">
            <div style={{ fontSize: 12.5, color: "var(--sec60)", marginBottom: 8, fontWeight: 600 }}>Toque num valor para editar ou somar, como numa planilha. Toque no nome para renomear a categoria. Vermelho passou do orçado.</div>
            <div className="tblwrap">
              <table className="tb">
                <thead><tr><th>Categoria</th><th>Orçado</th>{MESES.map((m) => <th key={m}>{m}</th>)}<th>Total</th></tr></thead>
                <tbody>
                  {custosAno.map((c, ci) => {
                    const tot = c.meses.reduce((s, v) => s + (v || 0), 0);
                    return (
                      <tr key={ci}>
                        <td className="cell" style={{ color: "var(--label)" }} onClick={() => setModal({ type: "editcat", ano: anoCustos, ci, nome: c.nome, orcado: c.orcado })}>{c.nome}</td>
                        <td className="cell" onClick={() => setModal({ type: "orcado", ano: anoCustos, ci, valor: c.orcado, nome: c.nome })}>{c.orcado ? fmt0(c.orcado) : "—"}</td>
                        {c.meses.map((v, mi) => (
                          <td key={mi} className={"cell " + (!v ? "zero" : c.orcado && v > c.orcado ? "over" : "")}
                            onClick={() => setModal({ type: "custo", ano: anoCustos, ci, mi, valor: v, nome: c.nome })}>
                            {v ? fmt0(v) : "·"}
                          </td>
                        ))}
                        <td style={{ fontWeight: 700 }}>{fmt0(tot)}</td>
                      </tr>
                    );
                  })}
                  <tr className="tot">
                    <td>Total</td>
                    <td>{fmt0(custosAno.reduce((s, c) => s + (c.orcado || 0), 0))}</td>
                    {MESES.map((_, mi) => <td key={mi}>{fmt0(custosAno.reduce((s, c) => s + (c.meses[mi] || 0), 0))}</td>)}
                    <td>{fmt0(custosAno.reduce((s, c) => s + c.meses.reduce((x, v) => x + (v || 0), 0), 0))}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div style={{ marginTop: 12 }}>
            <button className="btn btn-glass" onClick={() => setModal({ type: "addcat" })}>＋ Nova categoria</button>
          </div>
        </>)}

        {/* ================= HISTÓRICO ================= */}

      </div>
      </div>

      <nav className="tabbar">
        {[["resumo", "Resumo", Ic.home], ["caixinhas", "Caixinhas", Ic.box], ["fluxo", "Fluxo", Ic.cal], ["metas", "Metas", Ic.target], ["analise", "Análise", Ic.chart], ["custos", "Custos", Ic.card]].map(([k, l, I]) => (
          <button key={k} className={tab === k ? "on" : ""} onClick={() => setTab(k)}>{I(tab === k)}<span>{l}</span></button>
        ))}
      </nav>

      {toast && <div className="toast">{toast}</div>}

      {modal?.type === "atualizar" && <SheetAtualizar caixinhas={data.caixinhas} onSave={salvarAtualizacaoDiaria} onClose={() => setModal(null)} />}
      {modal?.type === "detalhe" && <SheetDetalhe cx={data.caixinhas.find((c) => c.id === modal.cx.id) || modal.cx} serie={serieCaixinha[modal.cx.id] || []} historico={data.historico} anoMeta={anoMeta} onEdit={() => setModal({ type: "editcx", cx: modal.cx })} onClose={() => setModal(null)} />}
      {modal?.type === "editcx" && <SheetCaixinha cx={modal.cx ? data.caixinhas.find((c) => c.id === modal.cx.id) : null} onSave={salvarCaixinha} onDelete={excluirCaixinha} onClose={() => setModal(null)} />}
      {modal?.type === "custo" && <SheetValor titulo={modal.nome} sub={`${MESES_FULL[modal.mi]} de ${modal.ano}`} valor={modal.valor} onSave={(v) => editarCusto(modal.ano, modal.ci, modal.mi, v)} onClose={() => setModal(null)} />}
      {modal?.type === "orcado" && <SheetValor titulo={modal.nome} sub="Orçamento mensal" valor={modal.valor} onSave={(v) => editarOrcado(modal.ano, modal.ci, v)} onClose={() => setModal(null)} />}
      {modal?.type === "addcat" && <SheetCategoria ano={anoCustos} onSave={addCategoria} onClose={() => setModal(null)} />}
      {modal?.type === "editcat" && <SheetCategoriaEdit ano={modal.ano} ci={modal.ci} nome={modal.nome} orcado={modal.orcado} onSave={renomearCategoria} onDelete={removerCategoria} onClose={() => setModal(null)} />}
      {modal?.type === "metas" && <SheetMetas cx={data.caixinhas.find((c) => c.id === modal.cx.id) || modal.cx} onSave={salvarMetas} onClose={() => setModal(null)} />}
      {modal?.type === "lanc" && <SheetLancamento dia={modal.dia} lanc={modal.lanc} categorias={(data.custos[parseInt((modal.dia || hoje()).slice(0, 4))] || data.custos[anoAtual] || []).map((c) => c.nome)} caixinhas={data.caixinhas} onSave={salvarLancamento} onDelete={excluirLancamento} onClose={() => setModal(null)} />}
      {modal?.type === "receber" && <SheetRecebimento dia={modal.dia} caixinhas={data.caixinhas} onSave={salvarRecebimento} onClose={() => setModal(null)} />}
      {modal?.type === "dia" && <SheetDia dia={modal.dia} fluxoDias={fluxoDias} caixinhas={data.caixinhas} setModal={setModal} onClose={() => setModal(null)} />}
      {modal?.type === "historico" && <SheetHistorico historicoPorDia={historicoPorDia} caixinhas={data.caixinhas} onClose={() => setModal(null)} />}
      {modal?.type === "gastodiario" && <SheetValor titulo="Gasto diário estimado" sub="Usado para projetar os dias futuros sem lançamentos" valor={data.fluxo.gastoDiario} onSave={salvarGastoDiario} onClose={() => setModal(null)} />}
    </div>
  );
}

// ============ METAS E SIMULAÇÃO ============
function Metas({ data, setModal }) {
  const anoAtual = new Date().getFullYear();
  const comMeta = data.caixinhas.filter((c) => c.metas && Object.keys(c.metas).length);
  const [alvoId, setAlvoId] = useState(comMeta[0]?.id || data.caixinhas[0]?.id);
  const cx = data.caixinhas.find((c) => c.id === alvoId) || data.caixinhas[0];
  const metaAnos = Object.keys(cx?.metas || {}).map(Number).sort();
  const [anoAlvo, setAnoAlvo] = useState(metaAnos[0] || anoAtual + 1);
  const metaValor = cx?.metas?.[anoAlvo];

  // ritmo observado nos últimos 90 dias
  const ritmo = useMemo(() => {
    if (!cx) return 0;
    const corte = addDias(hoje(), -90);
    const evs = data.historico.filter((h) => h.caixinha === cx.nome && h.data >= corte);
    const liq = evs.reduce((s, h) => s + (h.novo - h.anterior), 0);
    return liq > 0 ? (liq / 90) * 30 : 0;
  }, [data, cx]);

  const [aporte, setAporte] = useState(null);
  const [taxa, setTaxa] = useState(0.9);
  const aporteUsado = aporte == null ? Math.round(ritmo) : aporte;

  // projeção mês a mês com juros compostos
  const proj = useMemo(() => {
    if (!cx) return [];
    const out = [];
    let v = cx.valor;
    for (let m = 0; m <= 60; m++) {
      out.push({ mes: m, valor: v });
      v = v * (1 + taxa / 100) + aporteUsado;
    }
    return out;
  }, [cx, aporteUsado, taxa]);

  const alvo = metaValor || (cx ? cx.valor * 1.5 : 0);
  const mesesAteAlvo = proj.findIndex((p) => p.valor >= alvo);
  const dataAlvo = mesesAteAlvo > 0 ? addDias(hoje(), mesesAteAlvo * 30) : null;

  // quanto precisa por mês para chegar na data da meta (31/12 do ano alvo)
  const mesesAteFimAno = Math.max(1, (anoAlvo - anoAtual) * 12 + (12 - new Date().getMonth()));
  const necessario = (() => {
    if (!metaValor || !cx) return 0;
    const i = taxa / 100;
    const fv = cx.valor * Math.pow(1 + i, mesesAteFimAno);
    const falta = metaValor - fv;
    if (falta <= 0) return 0;
    const fator = i > 0 ? (Math.pow(1 + i, mesesAteFimAno) - 1) / i : mesesAteFimAno;
    return falta / fator;
  })();

  const pontos = proj.filter((p) => p.mes % 3 === 0).map((p) => ({ data: addDias(hoje(), p.mes * 30), total: p.valor }));

  if (!cx) return <div className="empty">Crie uma caixinha para simular metas.</div>;

  return (<>
    <div className="lt">Metas</div>
    <div className="cols">
    <div className="stack">
      <div className="card pad">
        <label className="fld" style={{ marginTop: 0 }}>Caixinha</label>
        <select className="inp" value={alvoId} onChange={(e) => { setAlvoId(e.target.value); setAporte(null); }}>
          {data.caixinhas.map((c) => <option key={c.id} value={c.id}>{c.nome}</option>)}
        </select>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: 14 }}>
          <div>
            <div style={{ fontSize: 13, fontWeight: 700, color: "var(--sec60)", textTransform: "uppercase", letterSpacing: ".05em" }}>Hoje</div>
            <div className="num" style={{ fontSize: 26, fontWeight: 800 }}>{fmt(cx.valor)}</div>
          </div>
          <button className="link" onClick={() => setModal({ type: "metas", cx })}>Editar metas</button>
        </div>
        {metaAnos.length > 0 && (
          <div className="chipbar" style={{ paddingTop: 12 }}>
            {metaAnos.map((a) => (
              <button key={a} className={"chip" + (anoAlvo === a ? " on" : "")} onClick={() => setAnoAlvo(a)}>Meta {a}: {fmt0(cx.metas[a])}</button>
            ))}
          </div>
        )}
        {metaValor ? (
          <>
            <div className="bar" style={{ marginTop: 10 }}><div style={{ width: Math.min(100, (cx.valor / metaValor) * 100) + "%", background: cx.cor }} /></div>
            <div style={{ display: "flex", justifyContent: "space-between", fontSize: 12.5, color: "var(--sec60)", marginTop: 6, fontWeight: 600 }} className="num">
              <span>{Math.round((cx.valor / metaValor) * 100)}% da meta</span>
              <span>faltam {fmt0(Math.max(0, metaValor - cx.valor))}</span>
            </div>
          </>
        ) : (
          <div style={{ fontSize: 14, color: "var(--sec60)", marginTop: 10 }}>Esta caixinha não tem meta definida. Use a simulação abaixo ou crie uma meta.</div>
        )}
      </div>

      <div className="card pad">
        <div style={{ fontSize: 16, fontWeight: 750, marginBottom: 2 }}>Simulação</div>
        <div style={{ fontSize: 13.5, color: "var(--sec60)", marginBottom: 12 }}>Mexa nos valores e veja quando você chega lá.</div>

        <div style={{ display: "flex", justifyContent: "space-between", fontSize: 14, fontWeight: 650 }}>
          <span>Guardar por mês</span><span className="num">{fmt0(aporteUsado)}</span>
        </div>
        <input type="range" min="0" max="8000" step="50" value={aporteUsado} onChange={(e) => setAporte(parseInt(e.target.value))}
          style={{ width: "100%", accentColor: "#007AFF", marginTop: 6, height: 30 }} />
        {aporte == null && ritmo > 0 && <div style={{ fontSize: 12.5, color: "var(--sec60)", fontWeight: 600 }}>Começando pelo seu ritmo real dos últimos 90 dias.</div>}

        <div style={{ display: "flex", justifyContent: "space-between", fontSize: 14, fontWeight: 650, marginTop: 14 }}>
          <span>Rendimento ao mês</span><span className="num">{taxa.toFixed(2)}%</span>
        </div>
        <input type="range" min="0" max="2" step="0.05" value={taxa} onChange={(e) => setTaxa(parseFloat(e.target.value))}
          style={{ width: "100%", accentColor: "#34C759", marginTop: 6, height: 30 }} />
        <div style={{ fontSize: 12.5, color: "var(--sec60)", fontWeight: 600 }}>Poupança rende perto de 0,5% e o CDI perto de 0,9% ao mês.</div>
      </div>
    </div>

    <div className="stack">
      <div className="stats" style={{ marginTop: 12 }}>
        <div className="stat">
          <div className="k">Chega na meta em</div>
          <div className="v num">{mesesAteAlvo > 0 ? (mesesAteAlvo >= 60 ? "5+ anos" : mesesAteAlvo + (mesesAteAlvo === 1 ? " mês" : " meses")) : "já chegou"}</div>
          <div className="s num">{dataAlvo ? "por volta de " + fmtData(dataAlvo) : "meta alcançada"}</div>
        </div>
        <div className="stat">
          <div className="k">Alvo</div>
          <div className="v num">{fmt0(alvo)}</div>
          <div className="s">{metaValor ? "meta de " + anoAlvo : "simulação livre"}</div>
        </div>
        <div className="stat">
          <div className="k">Em 12 meses</div>
          <div className="v num pos">{fmt0(proj[12]?.valor || 0)}</div>
          <div className="s num">+{fmt0((proj[12]?.valor || 0) - cx.valor)}</div>
        </div>
        <div className="stat">
          <div className="k">Em 24 meses</div>
          <div className="v num pos">{fmt0(proj[24]?.valor || 0)}</div>
          <div className="s num">+{fmt0((proj[24]?.valor || 0) - cx.valor)}</div>
        </div>
      </div>

      {metaValor && necessario > 0 && (
        <div className="card pad" style={{ marginTop: 12, display: "flex", gap: 12, alignItems: "center" }}>
          <div className="icon-sq"><CxIcon id="trophy" /></div>
          <div>
            <div style={{ fontSize: 15, fontWeight: 700 }}>Para fechar {anoAlvo} na meta</div>
            <div style={{ fontSize: 13.5, color: "var(--sec60)" }} className="num">
              guarde <b>{fmt(necessario)}</b> por mês nos próximos {mesesAteFimAno} meses
            </div>
          </div>
        </div>
      )}
      {metaValor && necessario === 0 && (
        <div className="card pad" style={{ marginTop: 12, fontSize: 14.5, fontWeight: 650 }}>
          No ritmo atual, a meta de {anoAlvo} já está garantida.
        </div>
      )}

      <div className="card pad" style={{ marginTop: 12 }}>
        <div style={{ fontSize: 15, fontWeight: 750, marginBottom: 8 }}>Crescimento projetado · 5 anos</div>
        <LineChart points={pontos} altura={150} />
      </div>
    </div>
    </div>
  </>);
}

// ============ FLUXO DE CAIXA (Conta em Dia) ============
function Fluxo({ data, fluxoDias, somaCaixinhas, setModal }) {
  const [horizonte, setHorizonte] = useState("30");
  const H = hoje();
  const [mesVis, setMesVis] = useState(H.slice(0, 7)); // "YYYY-MM"

  const futuros = fluxoDias.filter((d) => d.data >= H && d.data <= addDias(H, parseInt(horizonte)));
  const pontos = futuros.map((d) => ({ data: d.data, total: d.saldo }));
  const menor = futuros.reduce((m, d) => (d.saldo < m.saldo ? d : m), futuros[0] || { saldo: 0, data: H });
  const negativo = futuros.find((d) => d.saldo < 0);

  const doMes = fluxoDias.filter((d) => d.data.slice(0, 7) === mesVis);
  const [yv, mv] = mesVis.split("-").map(Number);
  const mudaMes = (n) => {
    const d = new Date(yv, mv - 1 + n, 15);
    setMesVis(d.toISOString().slice(0, 7));
  };
  const entMes = doMes.filter((d) => !d.estimado).reduce((s, d) => s + d.e, 0);
  const saiMes = doMes.filter((d) => !d.estimado).reduce((s, d) => s + d.s, 0);

  return (<>
    <div className="lt">Fluxo de caixa</div>
    
    <div className="cols">
    <div className="stack">
    <div className="card hero">
      <div className="cap">Saldo hoje · Dia a dia + Conta</div>
      <div className="big num">{fmt(somaCaixinhas)}</div>
      <span className="sync">Soma de {data.caixinhas.filter((c) => c.noFluxo).map((c) => c.nome).join(" e ")}</span>
      <div className="seg">
        {[["30", "30 dias"], ["60", "60 dias"], ["90", "90 dias"]].map(([v, l]) => (
          <button key={v} className={horizonte === v ? "on" : ""} onClick={() => setHorizonte(v)}>{l}</button>
        ))}
      </div>
      <LineChart points={pontos} altura={140} />
      <div style={{ display: "flex", justifyContent: "space-between", marginTop: 10, fontSize: 13, fontWeight: 600 }}>
        <span className="mut">Projeção com gasto de {fmt(data.fluxo.gastoDiario)}/dia · <button className="link" style={{ fontSize: 13 }} onClick={() => setModal({ type: "gastodiario" })}>ajustar</button></span>
      </div>
    </div>

    {negativo ? (
      <div className="warn"><span style={{ fontSize: 20 }}>🚨</span><span>O saldo projetado fica <b>negativo em {fmtData(negativo.data)}</b>. Planeje um reforço antes disso.</span></div>
    ) : menor && (
      <div className="card pad" style={{ marginTop: 12, display: "flex", gap: 12, alignItems: "center" }}>
        <div className="icon-sq"><CxIcon id="down" /></div>
        <div>
          <div style={{ fontSize: 15, fontWeight: 650 }}>Menor saldo nos próximos {horizonte} dias</div>
          <div style={{ fontSize: 13, color: "var(--sec60)" }} className="num">{fmt(menor.saldo)} em {fmtData(menor.data)} ({diaSemana(menor.data)})</div>
        </div>
      </div>
    )}

    <div style={{ marginTop: 12, display: "grid", gap: 10 }}>
      <button className="btn btn-blue" onClick={() => setModal({ type: "receber", dia: H })}>Recebi um valor</button>
      <button className="btn btn-glass" onClick={() => setModal({ type: "lanc", dia: H, lanc: null })}>＋ Outro lançamento</button>
    </div>

    </div>
    <div className="stack">
    <div className="section-h" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: 12 }}>
      <button className="link" onClick={() => mudaMes(-1)}>‹ anterior</button>
      <span>{MESES_FULL[mv - 1]} de {yv}</span>
      <button className="link" onClick={() => mudaMes(1)}>próximo ›</button>
    </div>
    <div className="stats" style={{ marginBottom: 12 }}>
      <div className="stat"><div className="k">Entradas no mês</div><div className="v num pos">+{fmt(entMes)}</div></div>
      <div className="stat"><div className="k">Saídas no mês</div><div className="v num neg">−{fmt(saiMes)}</div></div>
    </div>
    <div className="card">
      {doMes.length === 0 && <div className="empty">Sem dados neste mês.</div>}
      {doMes.map((d) => {
        const ehHoje = d.data === H;
        const temMov = d.e > 0 || d.s > 0;
        if (!temMov && !ehHoje && !d.futuro) return null;
        return (
          <div key={d.data} className={"dia-row" + (d.estimado ? " est" : "")}
            onClick={() => setModal({ type: "dia", dia: d.data })}>
            <div className={"dia-badge" + (ehHoje ? " hoje" : "")}>
              <div className="dn num">{parseInt(d.data.slice(8))}</div>
              <div className="dw">{ehHoje ? "hoje" : diaSemana(d.data)}</div>
            </div>
            <div>
              <div className="dia-mov">
                {d.e > 0 && <span className="pos num">＋{fmt(d.e)}</span>}
                {d.s > 0 && <span className="neg num">−{fmt(d.s)}</span>}
                {!temMov && d.futuro && <span className="mut">sem lançamentos</span>}
                {!temMov && !d.futuro && <span className="mut">sem movimentos</span>}
              </div>
              {d.itens.some((i) => i.auto) && <div style={{ fontSize: 11, color: "var(--blue)", fontWeight: 700 }}>💧 ajuste automático</div>}
              {d.itens.some((i) => i.plan) && d.futuro && <div style={{ fontSize: 11, color: "var(--orange)", fontWeight: 700 }}>planejado</div>}
              {d.itens.filter((i) => i.tipo && i.tipo !== "auto").slice(0, 4).map((i, k) => (
                <div key={k} style={{ fontSize: 11.5, color: "var(--sec60)", fontWeight: 650 }}>{descreverLanc(i, data.caixinhas)}</div>
              ))}
              {d.estimado && <div style={{ fontSize: 11, color: "var(--sec60)" }}>gasto estimado</div>}
            </div>
            <div className="dia-saldo">
              <div className={"v num " + (d.saldo < 0 ? "neg" : "")}>{fmt(d.saldo)}</div>
              <div className="t">{d.futuro ? "projetado" : "saldo"}</div>
            </div>
          </div>
        );
      })}
    </div>
    <div className="footer-note">Toque em um dia para ver e editar as transações. Dias claros são projeção.</div>
    </div>
    </div>
  </>);
}

// ============ ANÁLISE ============
function Analise({ data }) {
  const anoAtual = new Date().getFullYear();
  const mesAtual = new Date().getMonth();
  const [de, setDe] = useState(addDias(hoje(), -30));
  const [ate, setAte] = useState(hoje());
  const [selCx, setSelCx] = useState("todas");
  const [anoEco, setAnoEco] = useState(String(anoAtual));
  const anosCustos = Object.keys(data.custos).map(Number).sort();
  const [anoA, setAnoA] = useState(anosCustos.length > 1 ? anosCustos[anosCustos.length - 2] : anosCustos[0]);
  const [anoB, setAnoB] = useState(anosCustos[anosCustos.length - 1]);

  // ---------- movimentos das caixinhas no período ----------
  const eventos = useMemo(
    () => data.historico.filter((h) => h.data >= de && h.data <= ate && (selCx === "todas" || h.caixinha === selCx)),
    [data, de, ate, selCx]
  );
  const entradas = eventos.filter((h) => h.novo > h.anterior).reduce((s, h) => s + (h.novo - h.anterior), 0);
  const saidas = eventos.filter((h) => h.novo < h.anterior).reduce((s, h) => s + (h.anterior - h.novo), 0);
  const liquido = entradas - saidas;
  const diasComRegistro = new Set(eventos.map((h) => h.data)).size;

  const rendimento = useMemo(
    () => eventos.filter((h) => h.novo > h.anterior && !h.transf).reduce((s, h) => s + (h.novo - h.anterior), 0),
    [eventos]
  );
  const baseMedia = useMemo(() => {
    const nomes = selCx === "todas" ? data.caixinhas.map((c) => c.nome) : [selCx];
    return data.caixinhas.filter((c) => nomes.includes(c.nome)).reduce((s, c) => s + c.valor, 0);
  }, [data, selCx]);
  const diasPeriodo = Math.max(1, diasEntre(de, ate) + 1);
  const rendMes = rendimento * (30 / diasPeriodo);
  const pctMes = baseMedia > 0 ? (rendMes / baseMedia) * 100 : 0;

  // ---------- evolução: patrimônio ou caixinha filtrada ----------
  const serieEvolucao = useMemo(() => {
    if (selCx === "todas") return data.snapshots.filter((s) => s.data >= de && s.data <= ate);
    const evs = data.historico.filter((h) => h.caixinha === selCx && h.data >= de && h.data <= ate);
    const pts = [];
    if (evs.length) { pts.push({ data: evs[0].data, total: evs[0].anterior }); evs.forEach((e) => pts.push({ data: e.data, total: e.novo })); }
    return pts;
  }, [data, de, ate, selCx]);

  // ---------- meses cobertos pelo período (para custos por categoria) ----------
  const mesesRange = useMemo(() => {
    const out = [];
    let y = parseInt(de.slice(0, 4)), m = parseInt(de.slice(5, 7)) - 1;
    const yF = parseInt(ate.slice(0, 4)), mF = parseInt(ate.slice(5, 7)) - 1;
    while (y < yF || (y === yF && m <= mF)) {
      out.push([y, m]);
      m++; if (m > 11) { m = 0; y++; }
    }
    return out;
  }, [de, ate]);

  const gastosPorCategoria = useMemo(() => {
    const mapa = {};
    mesesRange.forEach(([y, m]) => {
      (data.custos[y] || []).forEach((c) => { mapa[c.nome] = (mapa[c.nome] || 0) + (c.meses[m] || 0); });
    });
    return Object.entries(mapa).filter(([, v]) => v > 0).sort((a, b) => b[1] - a[1]);
  }, [data, mesesRange]);
  const totalGastos = gastosPorCategoria.reduce((s, [, v]) => s + v, 0);
  const CORES_CAT = [IOS.blue, IOS.teal, IOS.purple, IOS.orange, IOS.pink, IOS.indigo, IOS.mint, IOS.yellow, IOS.brown, IOS.gray];

  // ---------- orçamento do mês corrente ----------
  const orcamentoMes = useMemo(() => {
    return (data.custos[anoAtual] || [])
      .filter((c) => c.orcado > 0)
      .map((c) => ({ nome: c.nome, gasto: c.meses[mesAtual] || 0, orcado: c.orcado }))
      .sort((a, b) => b.gasto / b.orcado - a.gasto / a.orcado);
  }, [data, anoAtual, mesAtual]);

  // ---------- comparação entre anos ----------
  const totalAno = (ano) => (data.custos[ano] || []).reduce((s, c) => s + c.meses.reduce((x, v) => x + (v || 0), 0), 0);
  const seriesAno = (ano) => MESES.map((_, mi) => (data.custos[ano] || []).reduce((s, c) => s + (c.meses[mi] || 0), 0));

  // ---------- lançamentos do período (gastos reais e dia da semana) ----------
  const lancGastos = useMemo(
    () => data.fluxo.lanc.filter((l) => l.tipo === "gasto" && l.data >= de && l.data <= ate && l.data <= hoje()),
    [data, de, ate]
  );
  const maioresGastos = useMemo(() => [...lancGastos].sort((a, b) => (b.valor || b.s || 0) - (a.valor || a.s || 0)).slice(0, 6), [lancGastos]);
  const porDiaSemana = useMemo(() => {
    const soma = [0, 0, 0, 0, 0, 0, 0];
    lancGastos.forEach((l) => { soma[new Date(l.data + "T12:00:00").getDay()] += l.valor || l.s || 0; });
    return [soma[1], soma[2], soma[3], soma[4], soma[5], soma[6], soma[0]];
  }, [lancGastos]);
  const temGastosSemana = porDiaSemana.some((v) => v > 0);

  // ---------- gasto diário real vs projeção configurada ----------
  const saidasFluxo = useMemo(() => {
    return data.fluxo.lanc
      .filter((l) => l.data >= de && l.data <= ate && l.data <= hoje())
      .reduce((s, l) => s + efeitoNoFluxo(l, data.caixinhas).s, 0);
  }, [data, de, ate]);
  const diasPassados = Math.max(1, Math.min(diasEntre(de, hoje()), diasEntre(de, ate)) + 1);
  const gastoDiarioReal = saidasFluxo / diasPassados;

  const melhorDia = useMemo(() => {
    const m = {};
    eventos.forEach((h) => { m[h.data] = (m[h.data] || 0) + (h.novo - h.anterior); });
    const arr = Object.entries(m).sort((a, b) => b[1] - a[1]);
    return arr[0] || null;
  }, [eventos]);

  const porCaixinha = useMemo(() => {
    const m = {};
    eventos.forEach((h) => {
      if (!m[h.caixinha]) m[h.caixinha] = { entradas: 0, saidas: 0 };
      const d = h.novo - h.anterior;
      if (d > 0) m[h.caixinha].entradas += d; else m[h.caixinha].saidas += -d;
    });
    return Object.entries(m).sort((a, b) => (b[1].entradas - b[1].saidas) - (a[1].entradas - a[1].saidas));
  }, [eventos]);

  const eco = data.economia[anoEco] || [];
  const taxaMedia = (() => {
    const val = eco.filter(([ent]) => ent > 0);
    if (!val.length) return 0;
    return (val.reduce((s, [ent, e]) => s + (ent ? e / ent : 0), 0) / val.length) * 100;
  })();

  const nomeFiltro = selCx === "todas" ? "todas as caixinhas" : selCx;

  return (<>
    <div className="lt">Análise</div>

    <div className="card pad">
      <div className="chipbar" style={{ paddingBottom: 12 }}>
        {[["7 dias", -7], ["30 dias", -30], ["90 dias", -91], ["Este ano", null]].map(([l, n]) => (
          <button key={l} className="chip" onClick={() => { setAte(hoje()); setDe(n === null ? hoje().slice(0, 4) + "-01-01" : addDias(hoje(), n)); }}>{l}</button>
        ))}
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
        <div><label className="fld" style={{ margin: "0 2px 6px" }}>De</label><input type="date" className="inp num" value={de} onChange={(e) => setDe(e.target.value)} /></div>
        <div><label className="fld" style={{ margin: "0 2px 6px" }}>Até</label><input type="date" className="inp num" value={ate} onChange={(e) => setAte(e.target.value)} /></div>
      </div>
      <label className="fld">Caixinha</label>
      <select className="inp" value={selCx} onChange={(e) => setSelCx(e.target.value)}>
        <option value="todas">Todas as caixinhas</option>
        {data.caixinhas.map((c) => <option key={c.id} value={c.nome}>{c.nome}</option>)}
      </select>
    </div>

    <div className="cols">
    <div className="stack">

    <div className="stats" style={{ marginTop: 12 }}>
      <div className="stat"><div className="k">Rendimentos e aportes</div><div className="v num pos">+{fmt(entradas)}</div></div>
      <div className="stat"><div className="k">Retiradas</div><div className="v num neg">−{fmt(saidas)}</div></div>
      <div className="stat"><div className="k">Resultado líquido</div><div className={"v num " + (liquido >= 0 ? "pos" : "neg")}>{liquido >= 0 ? "+" : ""}{fmt(liquido)}</div><div className="s num">{diasComRegistro} dias com registro</div></div>
      <div className="stat"><div className="k">Só rendimento</div><div className="v num pos">+{fmt(rendimento)}</div><div className="s">sem contar aportes</div></div>
      <div className="stat"><div className="k">Rendimento ao mês</div><div className="v num pos">{pctMes.toFixed(2)}%</div><div className="s num">≈ {fmt(rendMes)} por mês</div></div>
      <div className="stat"><div className="k">Gasto diário real</div><div className="v num">{fmt(gastoDiarioReal)}</div><div className="s num">projeção usa {fmt(data.fluxo.gastoDiario)}</div></div>
    </div>

    <div className="section-h">Evolução · {nomeFiltro}</div>
    <div className="card pad">
      <LineChart points={serieEvolucao} altura={150} />
    </div>

    {melhorDia && (
      <div className="card pad" style={{ marginTop: 12, display: "flex", alignItems: "center", gap: 12 }}>
        <div className="icon-sq"><CxIcon id="trophy" /></div>
        <div>
          <div style={{ fontSize: 15, fontWeight: 650 }}>Melhor dia do período</div>
          <div style={{ fontSize: 13, color: "var(--sec60)" }} className="num">{fmtData(melhorDia[0])} · <span className="pos" style={{ fontWeight: 750 }}>+{fmt(melhorDia[1])}</span></div>
        </div>
      </div>
    )}

    <div className="section-h">Por caixinha no período</div>
    <div className="card">
      {porCaixinha.length === 0 && <div className="empty">Nenhum movimento no período.</div>}
      {porCaixinha.map(([nome, v]) => {
        const cx = data.caixinhas.find((c) => c.nome === nome);
        const liq = v.entradas - v.saidas;
        return (
          <div className="row" key={nome}>
            <div className="icon-sq"><CxIcon id={cx?.icone || "wallet"} /></div>
            <div>
              <div className="r-title" style={{ fontWeight: 650 }}>{nome}</div>
              <div className="r-sub num">+{fmtShort(v.entradas)} · −{fmtShort(v.saidas)}</div>
            </div>
            <div className="r-val"><div className={"v num " + (liq >= 0 ? "pos" : "neg")}>{liq >= 0 ? "+" : ""}{fmt(liq)}</div></div>
          </div>
        );
      })}
    </div>

    <div className="section-h">Maiores gastos do período</div>
    <div className="card">
      {maioresGastos.length === 0 && <div className="empty">Nenhum gasto lançado no fluxo neste período. Lance gastos com categoria para ver este ranking.</div>}
      {maioresGastos.map((l, i) => (
        <div className="row noicon" key={i}>
          <div>
            <div className="r-title" style={{ fontWeight: 650, fontSize: 15 }}>{l.categoria || "Gasto"}</div>
            <div className="r-sub num">{fmtData(l.data)}{l.desc ? " · " + l.desc : ""}</div>
          </div>
          <div className="r-val"><div className="v num neg">−{fmt(l.valor || l.s || 0)}</div></div>
        </div>
      ))}
    </div>

    </div>
    <div className="stack">

    <div className="section-h" style={{ marginTop: 12 }}>Gastos por categoria</div>
    <div className="card pad">
      <div style={{ fontSize: 12.5, color: "var(--sec60)", marginBottom: 10, fontWeight: 600 }}>
        Meses de {MESES[mesesRange[0]?.[1] ?? 0]}/{String(mesesRange[0]?.[0] ?? "").slice(2)} a {MESES[mesesRange[mesesRange.length - 1]?.[1] ?? 0]}/{String(mesesRange[mesesRange.length - 1]?.[0] ?? "").slice(2)}, pela tabela de custos.
      </div>
      {totalGastos > 0 ? (
        <Donut itens={gastosPorCategoria.slice(0, 8).map(([nome, v], i) => ({ nome, valor: v, cor: CORES_CAT[i % CORES_CAT.length] }))} total={totalGastos} />
      ) : <div className="empty">Sem gastos registrados nos meses do período.</div>}
      {gastosPorCategoria.slice(0, 8).map(([nome, v], i) => (
        <div key={nome} style={{ display: "flex", alignItems: "center", gap: 8, padding: "7px 0", borderBottom: "1px solid var(--sep)", fontSize: 14 }}>
          <span style={{ width: 9, height: 9, borderRadius: 99, background: CORES_CAT[i % CORES_CAT.length], flexShrink: 0 }} />
          <span style={{ fontWeight: 550 }}>{nome}</span>
          <span className="num" style={{ marginLeft: "auto", fontWeight: 700 }}>{fmt(v)}</span>
        </div>
      ))}
    </div>

    <div className="section-h">Orçamento de {MESES_FULL[mesAtual]}</div>
    <div className="card pad">
      {orcamentoMes.length === 0 && <div className="empty">Defina orçamentos nas categorias para acompanhar aqui.</div>}
      {orcamentoMes.map((c) => {
        const pct = Math.min(150, (c.gasto / c.orcado) * 100);
        const estourou = c.gasto > c.orcado;
        return (
          <div key={c.nome} style={{ marginBottom: 12 }}>
            <div style={{ display: "flex", justifyContent: "space-between", fontSize: 14, fontWeight: 650 }}>
              <span>{c.nome}</span>
              <span className={"num " + (estourou ? "neg" : "")}>{fmt0(c.gasto)} / {fmt0(c.orcado)}</span>
            </div>
            <div className="bar" style={{ marginTop: 5 }}><div style={{ width: Math.min(100, pct) + "%", background: estourou ? "var(--redB)" : "var(--greenB)" }} /></div>
          </div>
        );
      })}
    </div>

    {temGastosSemana && (<>
      <div className="section-h">Gasto por dia da semana</div>
      <div className="card pad">
        <div style={{ fontSize: 12.5, color: "var(--sec60)", marginBottom: 8, fontWeight: 600 }}>Só gastos lançados no fluxo, no período.</div>
        <Bars labels={["Seg", "Ter", "Qua", "Qui", "Sex", "Sáb", "Dom"]} series={[porDiaSemana]} cores={[IOS.purple]} />
      </div>
    </>)}

    {anosCustos.length > 1 && (<>
      <div className="section-h">Comparar anos</div>
      <div className="card pad">
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 10 }}>
          <select className="inp" value={anoA} onChange={(e) => setAnoA(parseInt(e.target.value))}>{anosCustos.map((a) => <option key={a} value={a}>{a}</option>)}</select>
          <select className="inp" value={anoB} onChange={(e) => setAnoB(parseInt(e.target.value))}>{anosCustos.map((a) => <option key={a} value={a}>{a}</option>)}</select>
        </div>
        <div className="chartwrap">
          <Bars labels={MESES} series={[seriesAno(anoB), seriesAno(anoA)]} cores={[IOS.blue, IOS.gray]} />
        </div>
        <span className="scrollhint">arraste para os lados</span>
        <div style={{ display: "flex", justifyContent: "space-between", fontSize: 14, fontWeight: 650, marginTop: 8 }} className="num">
          <span className="mut">{anoA}: {fmt0(totalAno(anoA))}</span>
          <span>{anoB}: {fmt0(totalAno(anoB))} <span className={totalAno(anoB) <= totalAno(anoA) ? "pos" : "neg"}>({totalAno(anoA) > 0 ? (((totalAno(anoB) - totalAno(anoA)) / totalAno(anoA)) * 100).toFixed(0) : 0}%)</span></span>
        </div>
      </div>
    </>)}

    <div className="section-h">Economia mensal</div>
    <div className="card pad">
      <div className="chipbar">
        {Object.keys(data.economia).map((a) => (
          <button key={a} className={"chip" + (anoEco === a ? " on" : "")} onClick={() => setAnoEco(a)}>{a}</button>
        ))}
      </div>
      <div style={{ fontSize: 12, color: "var(--sec60)", margin: "2px 0 8px" }}>Azul: quanto entrou · verde: quanto foi guardado</div>
      <div className="chartwrap">
      <Bars labels={MESES} series={[eco.map((x) => x[0]), eco.map((x) => x[1])]} cores={[IOS.blue, IOS.green]} />
      </div>
      <span className="scrollhint">arraste para os lados</span>
      <div style={{ display: "flex", justifyContent: "space-between", fontSize: 14, fontWeight: 650, marginTop: 8 }}>
        <span className="mut">Taxa média de economia em {anoEco}</span>
        <span className="pos num">{taxaMedia.toFixed(1)}%</span>
      </div>
    </div>

    </div>
    </div>
  </>);
}
function SheetHistorico({ historicoPorDia, caixinhas, onClose }) {
  const [busca, setBusca] = useState("");
  const filtrado = historicoPorDia
    .map(([dia, itens]) => [dia, itens.filter((h) => !busca || h.caixinha.toLowerCase().includes(busca.toLowerCase()))])
    .filter(([, itens]) => itens.length);
  return (
    <Sheet title="Histórico" onClose={onClose}>
      <div style={{ fontSize: 14, color: "var(--sec60)", marginBottom: 10 }}>Toda mudança de saldo nas caixinhas, dia a dia.</div>
      <input className="inp" placeholder="Buscar caixinha" value={busca} onChange={(e) => setBusca(e.target.value)} style={{ marginBottom: 14 }} />
      {filtrado.length === 0 && <div className="empty">Nenhuma atualização por aqui.</div>}
      {filtrado.slice(0, 60).map(([dia, itens]) => {
        const soma = itens.reduce((s, h) => s + (h.novo - h.anterior), 0);
        return (
          <div key={dia} style={{ marginBottom: 16 }}>
            <div className="section-h" style={{ margin: "0 4px 8px", display: "flex", justifyContent: "space-between" }}>
              <span>{fmtDataLonga(dia)}</span>
              <span className={"num " + (soma >= 0 ? "pos" : "neg")} style={{ textTransform: "none", fontWeight: 700 }}>{soma >= 0 ? "+" : ""}{fmt(soma)}</span>
            </div>
            <div className="card">
              {itens.map((h, i) => {
                const cx = caixinhas.find((c) => c.nome === h.caixinha);
                const d = h.novo - h.anterior;
                return (
                  <div className="row" key={i}>
                    <div className="icon-sq"><CxIcon id={cx?.icone || "wallet"} /></div>
                    <div>
                      <div className="r-title" style={{ fontWeight: 650 }}>{h.caixinha}</div>
                      <div className="r-sub num">{fmt(h.anterior)} → {fmt(h.novo)}{h.transf ? " · transferência" : ""}</div>
                    </div>
                    <div className="r-val"><div className={"v num " + (d > 0 ? "pos" : d < 0 ? "neg" : "mut")}>{d > 0 ? "+" : ""}{fmt(d)}</div></div>
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
      {filtrado.length > 60 && <div className="footer-note">Mostrando os 60 dias mais recentes.</div>}
    </Sheet>
  );
}

// ============ Detalhe de um dia do fluxo ============
function SheetDia({ dia, fluxoDias, caixinhas, setModal, onClose }) {
  const d = fluxoDias.find((x) => x.data === dia);
  if (!d) return null;
  const itens = d.itens.filter((i) => !i.auto);
  const nome = (id) => caixinhas.find((c) => c.id === id)?.nome || "—";
  const valorDe = (l) => (l.valor != null ? l.valor : (l.e || l.s || 0));
  const ehEntrada = (l) => l.tipo === "entrada" || (!l.tipo && l.e > 0);

  return (
    <Sheet title={fmtDataLonga(dia)} onClose={onClose}>
      <div className="card pad" style={{ marginBottom: 12 }}>
        <div style={{ display: "flex", justifyContent: "space-between", fontSize: 15, fontWeight: 700 }}>
          <span>{d.futuro ? "Saldo projetado" : "Saldo do dia"}</span>
          <span className={"num " + (d.saldo < 0 ? "neg" : "")}>{fmt(d.saldo)}</span>
        </div>
        <div style={{ display: "flex", gap: 16, fontSize: 13.5, marginTop: 6, fontWeight: 650 }}>
          {d.e > 0 && <span className="pos num">entrou {fmt(d.e)}</span>}
          {d.s > 0 && <span className="neg num">saiu {fmt(d.s)}</span>}
          {d.e === 0 && d.s === 0 && <span className="mut">sem movimento no disponível</span>}
        </div>
        {d.estimado && <div style={{ fontSize: 12.5, color: "var(--sec60)", marginTop: 6 }}>Valor estimado pelo gasto diário médio, sem lançamentos reais.</div>}
      </div>

      <div className="section-h" style={{ marginTop: 0 }}>Transações ({itens.length})</div>
      <div className="card">
        {itens.length === 0 && <div className="empty">Nenhuma transação neste dia.</div>}
        {itens.map((l, i) => {
          const v = valorDe(l);
          const entrada = ehEntrada(l);
          return (
            <div className="row" key={i} style={{ cursor: "pointer" }} onClick={() => setModal({ type: "lanc", dia, lanc: l })}>
              <div className="icon-sq"><CxIcon id={l.tipo === "transf" ? "wallet" : entrada ? "cash" : "coffee"} /></div>
              <div style={{ minWidth: 0 }}>
                <div className="r-title" style={{ fontWeight: 650 }}>
                  {l.tipo === "transf" ? nome(l.origem) + " → " + nome(l.destino) : l.tipo === "gasto" ? l.categoria || "Gasto" : "Entrada"}
                </div>
                <div className="r-sub">
                  {l.tipo === "gasto" ? "sai de " + nome(l.origem) : l.tipo === "entrada" ? "entra em " + nome(l.destino) : "transferência"}
                  {l.desc ? " · " + l.desc : ""}
                  {l.plan ? " · planejado" : ""}
                </div>
              </div>
              <div className="r-val">
                <div className={"v num " + (l.tipo === "transf" ? "mut" : entrada ? "pos" : "neg")}>
                  {l.tipo === "transf" ? "" : entrada ? "+" : "−"}{fmt(v)}
                </div>
                <div className="d mut" style={{ fontWeight: 600 }}>editar ›</div>
              </div>
            </div>
          );
        })}
      </div>

      <div style={{ marginTop: 14, display: "grid", gap: 10 }}>
        <button className="btn btn-blue" onClick={() => setModal({ type: "lanc", dia, lanc: null })}>＋ Nova transação neste dia</button>
        <button className="btn btn-glass" onClick={() => setModal({ type: "receber", dia })}>Registrar um recebimento</button>
      </div>
    </Sheet>
  );
}

// ============ SHEETS ============
function SheetAtualizar({ caixinhas, onSave, onClose }) {
  const [parsed, setParsed] = useState(() => {
    const o = {}; caixinhas.forEach((c) => (o[c.id] = c.valor)); return o;
  });
  const totalNovo = caixinhas.reduce((s, c) => s + (isNaN(parsed[c.id]) ? c.valor : parsed[c.id]), 0);
  const totalAtual = caixinhas.reduce((s, c) => s + c.valor, 0);
  const diff = totalNovo - totalAtual;
  return (
    <Sheet title="Hoje" onClose={onClose}>
      <div style={{ fontSize: 14, color: "var(--sec60)", marginBottom: 14 }}>Digite o saldo de cada caixinha como aparece no banco.</div>
      {caixinhas.map((c) => {
        const p = parsed[c.id];
        const d = isNaN(p) ? 0 : p - c.valor;
        return (
          <div className="upd-item" key={c.id}>
            <div className="upd-top">
              <div className="icon-sq" style={{ width: 30, height: 30 }}><CxIcon id={c.icone} size={16} /></div>
              <span className="n">{c.nome}</span>
              <span className="a num">antes {fmt(c.valor)}</span>
            </div>
            <MoneyInput inicial={c.valor} onValor={(v) => setParsed((p) => ({ ...p, [c.id]: v }))} />
            {Math.abs(d) > 0.004 && (
              <div className={"num " + (d > 0 ? "pos" : "neg")} style={{ fontSize: 13, fontWeight: 700, marginTop: 6 }}>
                {d > 0 ? `▲ rendeu ${fmt(d)}` : `▼ saiu ${fmt(-d)}`}
              </div>
            )}
          </div>
        );
      })}
      <div className="card pad" style={{ marginTop: 4 }}>
        <div style={{ display: "flex", justifyContent: "space-between", fontWeight: 700, fontSize: 16 }}>
          <span>Novo total</span><span className="num">{fmt(totalNovo)}</span>
        </div>
        <div style={{ display: "flex", justifyContent: "space-between", fontSize: 14, marginTop: 4, fontWeight: 600 }} className={diff >= 0 ? "pos" : "neg"}>
          <span>Variação do dia</span><span className="num">{diff >= 0 ? "+" : ""}{fmt(diff)}</span>
        </div>
      </div>
      <div style={{ marginTop: 14 }}>
        <button className="btn btn-blue" onClick={() => onSave(parsed)}>Salvar dia</button>
      </div>
    </Sheet>
  );
}

function SheetDetalhe({ cx, serie, historico, anoMeta, onEdit, onClose }) {
  const evs = historico.filter((h) => h.caixinha === cx.nome);
  const entradas = evs.filter((h) => h.novo > h.anterior).reduce((s, h) => s + h.novo - h.anterior, 0);
  const saidas = evs.filter((h) => h.novo < h.anterior).reduce((s, h) => s + h.anterior - h.novo, 0);
  const meta = cx.metas?.[anoMeta];
  // projeção: ritmo médio dos últimos 30 dias
  let projecao = null;
  if (meta && cx.valor < meta) {
    const corte = addDias(hoje(), -30);
    const rec = evs.filter((h) => h.data >= corte);
    const dias = new Set(rec.map((h) => h.data)).size;
    const liq = rec.reduce((s, h) => s + h.novo - h.anterior, 0);
    if (dias >= 3 && liq > 0) {
      const porDia = liq / dias;
      projecao = Math.ceil((meta - cx.valor) / porDia);
    }
  }
  return (
    <Sheet title={cx.nome} onClose={onClose} action={<button className="link" onClick={onEdit}>Editar</button>}>
      <div className="card hero" style={{ paddingTop: 16 }}>
        <div className="cap" style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span className="icon-sq" style={{ width: 28, height: 28 }}><CxIcon id={cx.icone} size={15} /></span> Saldo atual
        </div>
        <div className="big num" style={{ fontSize: 32 }}>{fmt(cx.valor)}</div>
        {serie.length >= 2 && <div style={{ marginTop: 8 }}><LineChart points={serie} altura={120} /></div>}
      </div>
      <div className="stats" style={{ marginTop: 12 }}>
        <div className="stat"><div className="k">Entradas totais</div><div className="v num pos">+{fmt(entradas)}</div></div>
        <div className="stat"><div className="k">Saídas totais</div><div className="v num neg">−{fmt(saidas)}</div></div>
      </div>
      {meta && (
        <div className="card pad" style={{ marginTop: 12 }}>
          <div style={{ display: "flex", justifyContent: "space-between", fontSize: 15, fontWeight: 600, marginBottom: 7 }}>
            <span>Meta {anoMeta}</span>
            <span className="num">{Math.min(100, Math.round((cx.valor / meta) * 100))}%</span>
          </div>
          <div className="bar"><div style={{ width: Math.min(100, (cx.valor / meta) * 100) + "%", background: cx.cor }} /></div>
          <div style={{ display: "flex", justifyContent: "space-between", fontSize: 12, color: "var(--sec60)", marginTop: 5 }} className="num">
            <span>{fmt0(cx.valor)} de {fmt0(meta)}</span>
            <span>{cx.valor >= meta ? "Atingida 🎉" : `faltam ${fmt0(meta - cx.valor)}`}</span>
          </div>
          {projecao && (
            <div style={{ marginTop: 10, fontSize: 13, color: "var(--sec)", background: "#7676801F", borderRadius: 10, padding: "9px 12px" }}>
              No ritmo dos últimos 30 dias, a meta chega em <b>~{projecao} dias</b> ({fmtData(addDias(hoje(), projecao))}).
            </div>
          )}
        </div>
      )}
      <div className="section-h">Últimos movimentos</div>
      <div className="card">
        {evs.length === 0 && <div className="empty">Sem movimentos ainda.</div>}
        {[...evs].reverse().slice(0, 15).map((h, i) => {
          const d = h.novo - h.anterior;
          return (
            <div className="row noicon" key={i}>
              <div><div className="r-title num" style={{ fontSize: 15 }}>{fmtData(h.data)}</div><div className="r-sub num">{fmt(h.anterior)} → {fmt(h.novo)}</div></div>
              <div className="r-val"><div className={"v num " + (d > 0 ? "pos" : "neg")}>{d > 0 ? "+" : ""}{fmt(d)}</div></div>
            </div>
          );
        })}
      </div>
    </Sheet>
  );
}

function SheetCaixinha({ cx, onSave, onDelete, onClose }) {
  const anoAtual = new Date().getFullYear();
  const [nome, setNome] = useState(cx?.nome || "");
  const [icone, setIcone] = useState(cx?.icone || "wallet");
  const [cor, setCor] = useState(cx?.cor || IOS.blue);
  const [valor, setValor] = useState(0);
  const [meta1, setMeta1] = useState(cx?.metas?.[anoAtual] ?? NaN);
  const [meta2, setMeta2] = useState(cx?.metas?.[anoAtual + 1] ?? NaN);
  const ICONES = ["wallet", "shield", "hammer", "chart", "beach", "coffee", "bank", "cash", "plane", "car", "home", "ring", "gift", "phone", "grad", "health"];
  const salvar = () => {
    if (!nome.trim()) return;
    const metas = { ...(cx?.metas || {}) };
    const m1 = Number(meta1), m2 = Number(meta2);
    if (!isNaN(m1) && m1 > 0) metas[anoAtual] = m1; else delete metas[anoAtual];
    if (!isNaN(m2) && m2 > 0) metas[anoAtual + 1] = m2; else delete metas[anoAtual + 1];
    const out = { id: cx?.id, nome: nome.trim(), icone, cor, metas };
    if (!cx) out.valor = Number(valor) || 0;
    onSave(out);
  };
  return (
    <Sheet title={cx ? "Editar caixinha" : "Nova caixinha"} onClose={onClose}>
      <label className="fld">Nome</label>
      <input className="inp" value={nome} onChange={(e) => setNome(e.target.value)} placeholder="Ex.: Viagem Chile" />
      <label className="fld">Ícone</label>
      <div className="chipbar">
        {ICONES.map((ic) => (
          <button key={ic} className={"chip" + (icone === ic ? " on" : "")} style={{ padding: "8px 11px" }} onClick={() => setIcone(ic)}><CxIcon id={ic} size={18} /></button>
        ))}
      </div>
      <label className="fld">Cor nos gráficos</label>
      <div className="chipbar">
        {CORES_CAIXINHA.map((c) => (
          <button key={c} onClick={() => setCor(c)} className="chip" style={{ width: 34, height: 34, borderRadius: 99, background: c, padding: 0, outline: cor === c ? "3px solid rgba(0,0,0,.35)" : "none", outlineOffset: 2 }} aria-label={"cor " + c} />
        ))}
      </div>
      {!cx && (<><label className="fld">Valor inicial</label>
        <MoneyInput inicial={0} onValor={setValor} /></>)}
      <label className="fld">Meta {anoAtual} (opcional)</label>
      <MoneyInput inicial={cx?.metas?.[anoAtual]} onValor={setMeta1} />
      <label className="fld">Meta {anoAtual + 1} (opcional)</label>
      <MoneyInput inicial={cx?.metas?.[anoAtual + 1]} onValor={setMeta2} />
      <div style={{ marginTop: 18 }}>
        <button className="btn btn-blue" onClick={salvar}>Salvar</button>
      </div>
      {cx && (
        <div style={{ textAlign: "center", marginTop: 14 }}>
          <button className="link red" onClick={() => { if (confirm("Remover esta caixinha? O histórico dela continua no app.")) onDelete(cx.id); }}>Remover caixinha</button>
        </div>
      )}
    </Sheet>
  );
}

function SheetValor({ titulo, sub, valor, onSave, onClose }) {
  const [v, setV] = useState(valor ? String(valor).replace(".", ",") : "");
  const res = calcular(v);
  const temConta = temOperacao(v);
  return (
    <Sheet title={titulo} onClose={onClose}>
      <div style={{ fontSize: 14, color: "var(--sec60)", marginBottom: 10 }}>{sub}</div>
      <input className="inp num" type="text" inputMode="text" autoComplete="off" autoCorrect="off" spellCheck="false"
        autoFocus value={v} onChange={(e) => setV(e.target.value)} placeholder="0,00"
        style={{ fontSize: 22, fontWeight: 700, textAlign: "center", padding: 16 }} />
      <div style={{ display: "flex", gap: 8, marginTop: 10 }}>
        {["+", "−", "×", "÷"].map((op) => (
          <button key={op} className="chip" style={{ flex: 1, justifyContent: "center", fontSize: 18, fontWeight: 700 }}
            onClick={() => setV((x) => String(x) + ({ "−": "-", "×": "*", "÷": "/" }[op] || op))}>{op}</button>
        ))}
        <button className="chip" style={{ flex: 1, justifyContent: "center" }} onClick={() => setV("")}>limpar</button>
      </div>
      <div style={{ textAlign: "center", marginTop: 8, fontSize: 14, fontWeight: 700, minHeight: 20 }} className="num">
        {temConta && !isNaN(res) ? <span className="pos">= {fmt(res)}</span> : <span style={{ color: "var(--sec60)", fontWeight: 600 }}>Use os botões abaixo para somar ou subtrair</span>}
      </div>
      <div style={{ marginTop: 12 }}>
        <button className="btn btn-blue" onClick={() => onSave(isNaN(res) ? 0 : Math.round(res * 100) / 100)}>Salvar{!isNaN(res) && temConta ? " " + fmt(res) : ""}</button>
      </div>
    </Sheet>
  );
}

function SheetCategoria({ ano, onSave, onClose }) {
  const [nome, setNome] = useState("");
  const [orcado, setOrcado] = useState(0);
  return (
    <Sheet title="Nova categoria" onClose={onClose}>
      <div style={{ fontSize: 14, color: "var(--sec60)", marginBottom: 4 }}>Será adicionada em {ano}.</div>
      <label className="fld">Nome</label>
      <input className="inp" value={nome} onChange={(e) => setNome(e.target.value)} placeholder="Ex.: Streaming" />
      <label className="fld">Orçamento mensal (opcional)</label>
      <MoneyInput inicial={0} onValor={setOrcado} />
      <div style={{ marginTop: 18 }}>
        <button className="btn btn-blue" onClick={() => { if (nome.trim()) onSave(ano, nome.trim(), Number(orcado) || 0); }}>Adicionar</button>
      </div>
    </Sheet>
  );
}

// ============ Lançamento no fluxo ============
function SheetLancamento({ dia, lanc, categorias, caixinhas, onSave, onDelete, onClose }) {
  const disp = caixinhas.filter((c) => c.noFluxo);
  const padraoConta = (disp.find((c) => /conta/i.test(c.nome)) || disp[0] || caixinhas[0])?.id;
  const [tipo, setTipo] = useState(lanc?.tipo === "transf" ? "transf" : lanc?.tipo === "entrada" ? "entrada" : "gasto");
  const [dataL, setDataL] = useState(lanc?.data || dia);
  const [valor, setValor] = useState(lanc ? (lanc.valor ?? (lanc.e || lanc.s)) : NaN);
  const [origem, setOrigem] = useState(lanc?.origem || padraoConta);
  const [destino, setDestino] = useState(lanc?.destino || padraoConta);
  const [categoria, setCategoria] = useState(lanc?.categoria || "");
  const [desc, setDesc] = useState(lanc?.desc || "");

  const v = Number(valor);
  const faltaCategoria = tipo === "gasto" && !categoria;
  const mesmaCaixinha = tipo === "transf" && origem === destino;
  const podeSalvar = !isNaN(v) && v > 0 && !faltaCategoria && !mesmaCaixinha;

  const salvar = () => {
    if (!podeSalvar) return;
    const novo = { data: dataL, tipo, valor: v, desc: desc.trim() || undefined };
    if (tipo === "entrada") { novo.destino = destino; novo.e = v; novo.s = 0; }
    if (tipo === "gasto") { novo.origem = origem; novo.categoria = categoria; novo.e = 0; novo.s = v; }
    if (tipo === "transf") { novo.origem = origem; novo.destino = destino; novo.e = 0; novo.s = v; }
    if (dataL > hoje()) novo.plan = true;
    onSave(novo, lanc || null);
  };

  const Opcoes = ({ valorSel, aoMudar }) => (
    <select className="inp" value={valorSel} onChange={(e) => aoMudar(e.target.value)}>
      {caixinhas.map((c) => <option key={c.id} value={c.id}>{c.nome}{c.noFluxo ? " (disponível)" : ""}</option>)}
    </select>
  );

  return (
    <Sheet title={lanc ? "Editar lançamento" : "Novo lançamento"} onClose={onClose}>
      <div className="seg" style={{ marginTop: 4 }}>
        {[["gasto", "Gasto"], ["entrada", "Entrada"], ["transf", "Transferir"]].map(([k, l]) => (
          <button key={k} className={tipo === k ? "on" : ""} onClick={() => setTipo(k)}>{l}</button>
        ))}
      </div>

      <label className="fld">Valor</label>
      <MoneyInput inicial={lanc ? (lanc.valor ?? (lanc.e || lanc.s)) : undefined} onValor={setValor} autoFocus />

      {tipo === "entrada" && (<><label className="fld">Entra em qual caixinha</label><Opcoes valorSel={destino} aoMudar={setDestino} /></>)}
      {tipo === "gasto" && (<>
        <label className="fld">Sai de qual caixinha</label><Opcoes valorSel={origem} aoMudar={setOrigem} />
        <label className="fld">Categoria (obrigatória)</label>
        <select className="inp" value={categoria} onChange={(e) => setCategoria(e.target.value)}>
          <option value="">Escolha uma categoria</option>
          {categorias.map((c) => <option key={c} value={c}>{c}</option>)}
        </select>
        {faltaCategoria && <div style={{ fontSize: 13, color: "var(--orange)", fontWeight: 650, marginTop: 6 }}>Escolha a categoria para lançar o gasto.</div>}
      </>)}
      {tipo === "transf" && (<>
        <label className="fld">De</label><Opcoes valorSel={origem} aoMudar={setOrigem} />
        <label className="fld">Para</label><Opcoes valorSel={destino} aoMudar={setDestino} />
        {mesmaCaixinha && <div style={{ fontSize: 13, color: "var(--orange)", fontWeight: 650, marginTop: 6 }}>Escolha caixinhas diferentes.</div>}
      </>)}

      <label className="fld">Data</label>
      <input type="date" className="inp num" value={dataL} onChange={(ev) => setDataL(ev.target.value)} />
      {dataL > hoje() && <div style={{ fontSize: 13, color: "var(--orange)", fontWeight: 650, marginTop: 6 }}>Data futura: entra na projeção como planejado, sem mexer nos saldos.</div>}

      <label className="fld">Descrição (opcional)</label>
      <input className="inp" value={desc} onChange={(ev) => setDesc(ev.target.value)} placeholder="Ex.: mercado do mês, salário" />

      <div style={{ marginTop: 18 }}>
        <button className="btn btn-blue" onClick={salvar} disabled={!podeSalvar} style={{ opacity: podeSalvar ? 1 : .5 }}>Salvar</button>
      </div>
      {lanc && <div style={{ textAlign: "center", marginTop: 14 }}><button className="link red" onClick={() => onDelete(lanc)}>Remover lançamento</button></div>}
    </Sheet>
  );
}

// ============ Recebimento com distribuição ============
function SheetRecebimento({ dia, caixinhas, onSave, onClose }) {
  const disp = caixinhas.filter((c) => c.noFluxo);
  const contaPadrao = (disp.find((c) => /conta/i.test(c.nome)) || disp[0] || caixinhas[0])?.id;
  const [dataR, setDataR] = useState(dia);
  const [valor, setValor] = useState(NaN);
  const [entrada, setEntrada] = useState(contaPadrao);
  const [desc, setDesc] = useState("");
  const [partes, setPartes] = useState([]);

  const v = Number(valor) || 0;
  const distribuido = partes.reduce((s, p) => s + (Number(p.valor) || 0), 0);
  const sobra = Math.round((v - distribuido) * 100) / 100;
  const nomeEntrada = caixinhas.find((c) => c.id === entrada)?.nome || "";
  const podeSalvar = v > 0 && sobra >= -0.004;

  const addParte = () => {
    const usados = [entrada, ...partes.map((p) => p.destino)];
    const livre = caixinhas.find((c) => !usados.includes(c.id));
    setPartes([...partes, { destino: (livre || caixinhas[0]).id, valor: NaN, key: Date.now() }]);
  };
  const setParte = (i, campo, val) => setPartes((ps) => ps.map((p, k) => (k === i ? { ...p, [campo]: val } : p)));

  return (
    <Sheet title="Recebi um valor" onClose={onClose}>
      <div style={{ fontSize: 14, color: "var(--sec60)", marginBottom: 4 }}>Lance a entrada e já distribua entre as caixinhas.</div>

      <label className="fld">Valor recebido</label>
      <MoneyInput onValor={setValor} autoFocus />

      <label className="fld">Caiu em</label>
      <select className="inp" value={entrada} onChange={(e) => setEntrada(e.target.value)}>
        {caixinhas.map((c) => <option key={c.id} value={c.id}>{c.nome}</option>)}
      </select>

      <label className="fld">Distribuir para</label>
      {partes.length === 0 && <div style={{ fontSize: 13.5, color: "var(--sec60)", marginBottom: 8 }}>Sem distribuição, o valor fica todo em {nomeEntrada}.</div>}
      {partes.map((p, i) => (
        <div key={p.key} className="upd-item">
          <div className="upd-top">
            <select className="inp" style={{ padding: "9px 12px", fontSize: 15 }} value={p.destino} onChange={(e) => setParte(i, "destino", e.target.value)}>
              {caixinhas.filter((c) => c.id !== entrada).map((c) => <option key={c.id} value={c.id}>{c.nome}</option>)}
            </select>
            <button className="link red" style={{ marginLeft: "auto" }} onClick={() => setPartes(partes.filter((_, k) => k !== i))}>remover</button>
          </div>
          <MoneyInput onValor={(x) => setParte(i, "valor", x)} />
        </div>
      ))}
      <button className="btn btn-glass" onClick={addParte} style={{ marginTop: 4 }}>＋ Adicionar caixinha</button>

      {v > 0 && (
        <div className="card pad" style={{ marginTop: 14 }}>
          <div style={{ display: "flex", justifyContent: "space-between", fontSize: 15, fontWeight: 700 }}>
            <span>Fica em {nomeEntrada}</span>
            <span className={"num " + (sobra < 0 ? "neg" : "")}>{fmt(sobra)}</span>
          </div>
          {sobra < 0 && <div style={{ fontSize: 13, color: "var(--red)", fontWeight: 650, marginTop: 6 }}>A distribuição passou do valor recebido.</div>}
        </div>
      )}

      <label className="fld">Data</label>
      <input type="date" className="inp num" value={dataR} onChange={(e) => setDataR(e.target.value)} />
      <label className="fld">Descrição (opcional)</label>
      <input className="inp" value={desc} onChange={(e) => setDesc(e.target.value)} placeholder="Ex.: salário de setembro" />

      <div style={{ marginTop: 18 }}>
        <button className="btn btn-blue" disabled={!podeSalvar} style={{ opacity: podeSalvar ? 1 : .5 }}
          onClick={() => onSave({ data: dataR, valor: v, entrada, desc, partes: partes.map((p) => ({ destino: p.destino, valor: Number(p.valor) || 0 })) })}>
          Salvar recebimento
        </button>
      </div>
    </Sheet>
  );
}

// ============ Editar categoria de custo ============
function SheetCategoriaEdit({ ano, ci, nome: nomeIni, orcado: orcIni, onSave, onDelete, onClose }) {
  const [nome, setNome] = useState(nomeIni);
  const [orcado, setOrcado] = useState(orcIni || 0);
  return (
    <Sheet title="Editar categoria" onClose={onClose}>
      <label className="fld">Nome</label>
      <input className="inp" value={nome} onChange={(e) => setNome(e.target.value)} />
      <label className="fld">Orçamento mensal</label>
      <MoneyInput inicial={orcIni} onValor={setOrcado} />
      <div style={{ marginTop: 18 }}>
        <button className="btn btn-blue" onClick={() => nome.trim() && onSave(ano, ci, nome.trim(), Number(orcado) || 0)}>Salvar</button>
      </div>
      <div style={{ textAlign: "center", marginTop: 14 }}>
        <button className="link red" onClick={() => { if (window.confirm("Remover a categoria " + nomeIni + " e todos os valores dela neste ano?")) onDelete(ano, ci); }}>Remover categoria</button>
      </div>
    </Sheet>
  );
}

// ============ Metas de uma caixinha ============
function SheetMetas({ cx, onSave, onClose }) {
  const anoAtual = new Date().getFullYear();
  const anos = [anoAtual, anoAtual + 1, anoAtual + 2];
  const [metas, setMetas] = useState({ ...(cx.metas || {}) });
  const set = (ano, v) => setMetas((m) => { const n = { ...m }; if (!v || isNaN(v)) delete n[ano]; else n[ano] = v; return n; });
  return (
    <Sheet title={"Metas · " + cx.nome} onClose={onClose}>
      <div style={{ fontSize: 14, color: "var(--sec60)", marginBottom: 6 }}>Deixe em branco os anos sem meta.</div>
      {anos.map((a) => (
        <div key={a}>
          <label className="fld">Meta {a}</label>
          <MoneyInput inicial={cx.metas?.[a]} onValor={(v) => set(a, v)} />
        </div>
      ))}
      <div style={{ marginTop: 18 }}>
        <button className="btn btn-blue" onClick={() => onSave(cx.id, metas)}>Salvar metas</button>
      </div>
    </Sheet>
  );
}
